import moment from "moment";
import { default as momentTz } from "moment-timezone";
import React, { useLayoutEffect } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useMemo } from "react";
import { useRef } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import OrderSummary from "../ticketOrderSummary/OrderSummary";
import "./payment.css";
import { red } from "@mui/material/colors";
import Checkbox from "@mui/material/Checkbox";
import {
  GetAllOrderFormFieldsByEventId,
  ticktesCartItem,
  PersistShoppingCartSession,
  GetDiscountData,
  getPersistShopingCartData,
  clearCartSessionDiscountId,
  GetDiscountDetails, currentEventDetails,
} from "Actions/eventActions";
import { IoClose } from "react-icons/io5";
import * as constants from "Constants";
import {
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./PaymentForm";
import { axiosE } from "Service/service";
import { routeName } from "Service/env";
import { history } from "store";
import { IoArrowBack } from "react-icons/io5";
import Success from "../SuccessFull/Success";
import TimeOutScreen from "../SuccessFull/TimeOutScreen";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import store from "../../../../../store";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { parsePhoneNumberWithError, ParseError } from "libphonenumber-js";
import Linkify from "react-linkify";
import { Text } from "Constants";
import { AiFillCloseCircle, AiOutlineShoppingCart } from "react-icons/ai";
import { RiCoupon3Fill } from "react-icons/ri";
import dayjs from "dayjs";
import { Info } from "@material-ui/icons";
import Decimal from "decimal.js";
import LoginBeforeCheckOut from "../LoginBeforeCheckout/LoginBeforeCheckOut";

const libphonenumber = require("libphonenumber-js");

const countryFormatMap = {
  US: "(XXX) XXX-XXXX",
  CA: "(XXX) XXX-XXXX",
  GB: "XXXXX XXXXXX",
  IN: "XX XXXX-XXXX",
  // Add more countries and their phone number formats as needed
};

const Payment = ({
                   setOpenCheckOut,
                   currentEventDetails,
                   GetAllOrderFormFieldsByEventId,
                   dispatch,
                   results,
                   cartItems,
                   ticktesCartItem,
                   setContinueToCheckOut,
                   setIsNotLoggedIn,
                   isLoggedIn,
                   shoppingCartDetails,
                   PersistShoppingCartSession,
                   discountData,
                   minutes,
                   seconds,
                   paymentIntent,
                   setMinutes,
                   newCartItemsData,
                   setNewCartItemsData,
                   ticketQty,
                   Token = null,
                   recurringData,
                   hasCheckoutQuery,
                   GetDiscountDetails,
                   isPromo = true,
                 }) => {
  const [publicKey, setPublicKey] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState([]);
  const [updatedAdditionalInfo, setUpdatedAdditionalInfo] = useState([]);
  const stripePromise =
      paymentIntent?.PublicKey !== null
          ? loadStripe(paymentIntent?.PublicKey)
          : null;
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [leaveCheckOut, setLeaveCheckOut] = useState(false);
  const [isFreeTicket, setIsFreeTicket] = useState(false);
  const [showOrderSummary, setShowOrderSummary] = useState(false);
  const [isNotFilled, setIsNotFilled] = useState(false);
  const [checkboxValue, setCheckBoxValue] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [freeBtndisabled, setFreeBtndisabled] = useState(false);
  const [DiscountCodeExist, setDiscountCodeExist] = useState(false);
  const [isMultiUserDetails, setIsMultiUserDetails] = useState(false);
  // const [disableDialCode, setDisableDialCode] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("us"); // Default country code
  const [previousCountry, setPreviousCountry] = useState("us");
  const [newCartItems, setNewCartItems] = useState([]);
  const [appliedCode, setAppliedCode] = useState("");
  const [discountError, setDiscountError] = useState("");
  const [isPromoCode, setIsPromoCode] = useState(false);
  const [promoCode, setPromoCode] = useState(discountData?.DiscountCode);
  const [returnUrl, setReturnUrl] = useState(""); // add this at the top of your component
  const [cardProcessingFee, setCardProcessingFee] = useState(0);
  const [cartTotal, setCartTotal] = useState(0);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

  const lastPersistedMethod = useRef(null);
  const isPersistingRef = useRef(false);
  const newCartItemsRef = useRef([]);
  const checkoutFormRef = useRef(null);

  useEffect(() => {
    setIsMultiUserDetails(
        currentEventDetails.IsAnonymousAllowed == "False" ? true : false
    );

    // Fetch the user's IP address
    fetch(constants.API.Geolocation_V2)
        .then((response) => response.json())
        .then((data) => {
          // Extract the country code from the IP address data
          const countryCode = data.country.toLowerCase();
          setSelectedCountry(countryCode); // Set the default country
        })
        .catch((error) => {
          console.log("Error fetching IP address:", error);
        });
  }, []);

  // useEffect(() => {
  //   const CartItemsData = cartItems?.map((item) => {
  //     const AdditionalFee = Number(
  //       shoppingCartDetails?.CartSession?.AdditionalFee
  //     );
  //     const obj = Object.assign({}, item);
  //     obj["TaxAmount"] =
  //       (Number(item.Quantity) * Number(item.Price) * Number(item.TaxAmount)) /
  //       100;
  //     // if(discountData?.ResponseCode === false){
  //     if (item.isAbsorb === true) {
  //       obj["UBMeFeePercent"] = 0;
  //     } else {
  //       obj["UBMeFeePercent"] =
  //         (Number(item.Quantity) *
  //           Number(item.Price) *
  //           Number(item.UBMeFeePercent)) /
  //           100 +
  //         (Number(item.Price) === 0
  //           ? 0
  //           : Number(item.Quantity) * AdditionalFee);
  //     }
  //     // }
  //
  //     if (discountData?.ResponseCode) {
  //       if (Number(item.Price) === 0) obj["UBMeFeePercent"] = 0;
  //       if (
  //         discountData?.DiscountType === "Amount" &&
  //         discountData?.TicketsId?.includes(item.TicketId)
  //       ) {
  //         const newItemPrice =
  //           Number(item.Price) - Number(discountData?.disCountAmount);
  //         // console.log("newItemPrice", newItemPrice);
  //         obj["DiscountAmount"] =
  //           Number(item.Quantity) * Number(discountData?.disCountAmount);
  //         if (item.isAbsorb === true) {
  //           obj["UBMeFeePercent"] = 0;
  //         } else {
  //           obj["UBMeFeePercent"] =
  //             (Number(item.Quantity) *
  //               newItemPrice *
  //               Number(item.UBMeFeePercent)) /
  //               100 +
  //             (Number(item.Price) === 0
  //               ? 0
  //               : (Number(item.Quantity) *
  //                   newItemPrice *
  //                   Number(item.UBMeFeePercent)) /
  //                   100 ===
  //                 0
  //               ? 0
  //               : Number(item.Quantity) * AdditionalFee);
  //         }
  //       }
  //       if (
  //         discountData?.DiscountType !== "Amount" &&
  //         discountData?.TicketsId?.includes(item.TicketId)
  //       ) {
  //         obj["DiscountAmount"] =
  //           (Number(item.Quantity) *
  //             Number(item.Price) *
  //             Number(discountData?.disCountAmount)) /
  //           100;
  //         if (item.isAbsorb === true) {
  //           obj["UBMeFeePercent"] = 0;
  //         } else {
  //           obj["UBMeFeePercent"] =
  //             (Number(item.Quantity) *
  //               Number(
  //                 item.Price -
  //                   (Number(item.Price) *
  //                     Number(discountData?.disCountAmount)) /
  //                     100
  //               ) *
  //               Number(item.UBMeFeePercent)) /
  //               100 +
  //             (Number(item.Price) === 0
  //               ? 0
  //               : (Number(item.Quantity) *
  //                   Number(
  //                     item.Price -
  //                       (Number(item.Price) *
  //                         Number(discountData?.disCountAmount)) /
  //                         100
  //                   ) *
  //                   Number(item.UBMeFeePercent)) /
  //                   100 ===
  //                 0
  //               ? 0
  //               : Number(item.Quantity) * AdditionalFee);
  //         }
  //       }
  //     } else {
  //       if (discountData?.TicketsId?.includes(item.TicketId)) {
  //         obj["DiscountAmount"] = 0;
  //       }
  //     }
  //     if (item?.addon?.length > 0 && item.isAbsorb === false) {
  //       const result = {};
  //       let addonpercent = item.addon?.reduce((addonTotal, addon) => {
  //         let addOnPrice = addon.Price ? Number(addon.Price) : 0;
  //         const person = addon.person;
  //         if (!result[person]) {
  //           result[person] = 0;
  //         }
  //         if (discountData?.ResponseCode) {
  //           if (
  //             discountData?.DiscountType !== "Amount" &&
  //             discountData?.TicketsId?.includes(item.TicketId)
  //           ) {
  //             const percentageDiscount =
  //             (addOnPrice * Number(discountData?.disCountAmount)) / 100;
  //              addOnPrice = addOnPrice - percentageDiscount;
  //             if(obj["DiscountAmount"]){
  //               obj["DiscountAmount"] += percentageDiscount
  //             }else{
  //               obj["DiscountAmount"] = percentageDiscount
  //             }
  //           }
  //         }
  //
  //         result[person] += (addon.Price ? Number(addon.Price) : 0);
  //
  //         const percentFee = addOnPrice * 0.03;
  //         addonTotal += percentFee;
  //         return addonTotal;
  //       }, 0);
  //
  //       if(Number(item.Price) === 0){
  //         Object.keys(result).forEach((person) => {
  //           if (result[person] > 0) {
  //             addonpercent += AdditionalFee;
  //           }
  //         });
  //       }
  //
  //
  //       if (obj["UBMeFeePercent"]) {
  //         obj["UBMeFeePercent"] += Number(addonpercent);
  //       } else {
  //         obj["UBMeFeePercent"] = Number(addonpercent);
  //       }
  //     }
  //     return obj;
  //   });
  //
  //   CartItemsData.forEach((item) => sortSelectedSlots(item));
  //
  //   setNewCartItems(CartItemsData);
  // }, [cartItems, discountData]);

  /* --------------------
 * Helpers
 * -------------------- */
  const toNumber = (v) => Number(v) || 0;
  const round2 = (v) => Math.round((toNumber(v) + Number.EPSILON) * 100) / 100;

  /* ----------------- HELPER: COUNT TICKETS WITH PAID ADDON ----------------- */
  const getTicketsWithPaidAddon = (item) => {

    if (item.TicketType === "Paid") {
      return toNumber(item.Quantity);
    }

    const paidAddons =
        item.addon?.filter(a => toNumber(a.Price) > 0) || [];

    if (!paidAddons.length) return 0;

    // Count unique persons (ticket instances)
    const uniqueTickets = new Set(
        paidAddons.map(a => a.person)
    );

    return uniqueTickets.size;
  };

  /* ----------------- UBMe Fee ----------------- */
  const calculateUBMeFee = ({ quantity, price, feePercent, additionalFee, isAbsorb }) => {
    if (isAbsorb || quantity <= 0) return 0;
    return (quantity * price * feePercent) / 100 + quantity * additionalFee;
  };

  /* ----------------- Discount ----------------- */
  const calculateDiscountAmount = ({ quantity, price, discountData, discountType }) => {
    if (!discountData) return 0;

    if (discountType === "Amount") {
      return quantity * toNumber(discountData.disCountAmount);
    }

    return (quantity * price * toNumber(discountData.disCountAmount)) / 100;
  };

  /* ----------------- Add-ons ----------------- */
  const calculateAddonFee = ({
                               addonList = [],
                               discountData,
                               ticketId,
                               isAbsorb,
                               feePercent,
                               additionalFee,
                               quantity,
                             }) => {

    let addonOriginalTotal = 0;
    let addonAfterDiscount = 0;
    let addonDiscountTotal = 0;
    let addonFee = 0;

    if (!addonList.length || isAbsorb || quantity <= 0) {
      return {
        addonOriginalTotal: 0,
        addonAfterDiscount: 0,
        addonDiscountTotal: 0,
        addonFee: 0,
      };
    }

    addonList.forEach((addon) => {

      let price = toNumber(addon.Price);

      addonOriginalTotal += price;

      if (
          discountData?.ResponseCode &&
          discountData.DiscountType !== "Amount" &&
          discountData.TicketsId?.includes(ticketId)
      ) {
        const discount = (price * toNumber(discountData.disCountAmount)) / 100;
        price -= discount;
        addonDiscountTotal += discount;
      }

      addonAfterDiscount += price;

      addonFee += price * (feePercent / 100);

    });

    if (addonAfterDiscount > 0) {
      addonFee += additionalFee * quantity;
    }

    return {
      addonOriginalTotal: round2(addonOriginalTotal),
      addonAfterDiscount: round2(addonAfterDiscount),
      addonDiscountTotal: round2(addonDiscountTotal),
      addonFee: round2(addonFee),
    };
  };

  /* ----------------- Card Processing Fee ----------------- */
  const calculateCardProcessingFee = ({ baseAmount, cardFeePercent, cardFeeAdditional }) => {
    if (baseAmount <= 0 || cardFeePercent === 0) return 0;
    return (baseAmount + cardFeeAdditional) / (1 - cardFeePercent) - baseAmount;
  };

  /* =====================
   * MAIN CART CALCULATION
   * ===================== */
  useEffect(() => {

    const session = shoppingCartDetails?.CartSession || {};

    const additionalFee = toNumber(session.AdditionalFee);
    const taxPercent = toNumber(session.Tax) / 100;

    let cardFeePercent = 0;
    let cardFeeAdditional = 0;

    switch (selectedPaymentMethod) {
      case "klarna":
        cardFeePercent = toNumber(session.KlarnaProcessingFee) / 100;
        cardFeeAdditional = toNumber(session.KlarnaProcessingAdditionalFee);
        break;

      case "afterpay_clearpay":
        cardFeePercent = toNumber(session.AfterPayProcessingFee) / 100;
        cardFeeAdditional = toNumber(session.AfterPayProcessingAdditionalFee);
        break;

      default:
        cardFeePercent = toNumber(session.CardProcessingFee) / 100;
        cardFeeAdditional = toNumber(session.CardProcessingAdditionalFee);
    }

    /* ---------------- TOTAL TICKET COUNT ---------------- */

    const totalTicketCount = cartItems.reduce((total, item) => {
      return total + getTicketsWithPaidAddon(item);
    }, 0);

    let cardFeeEligibleBase = 0;
    let distributedCardAdditionalFee = 0;

    const CartItemsData = cartItems.map((item) => {

      const obj = { ...item };

      const quantity = toNumber(item.Quantity);
      const price = toNumber(item.Price);
      const isAbsorb = item.isAbsorb;

      const ticketsWithPaidAddon = getTicketsWithPaidAddon(item);

      /* ---------- ORIGINAL TOTAL ---------- */

      obj.OriginalTicketTotal = round2(price * quantity);

      /* ---------- DISCOUNT ---------- */

      const discountAmount =
          discountData?.ResponseCode &&
          discountData.TicketsId?.includes(item.TicketId)
              ? calculateDiscountAmount({
                quantity,
                price,
                discountData,
                discountType: discountData.DiscountType,
              })
              : 0;

      obj.DiscountAmount = round2(discountAmount);

      /* ---------- NET PRICE ---------- */

      const netTicketPrice = round2(obj.OriginalTicketTotal - discountAmount);
      obj.NetTicketPrice = netTicketPrice;

      /* ---------- UBMe FEE ---------- */

      const ubmeQuantity =
          item.TicketType === "Paid" ? quantity : ticketsWithPaidAddon;

      let ubmeFee = 0;
      if (price > 0) { // only for paid tickets
        ubmeFee = round2(
            calculateUBMeFee({
              quantity: ubmeQuantity,
              price: item.TicketType === "Paid" ? netTicketPrice / quantity : 0,
              feePercent: toNumber(item.UBMeFeePercent),
              additionalFee,
              isAbsorb,
            })
        );
      }

      obj.UBMeFeePercent = ubmeFee;

      /* ---------- ADDONS ---------- */

      obj.AddonOriginalTotal = 0;
      obj.AddonTotalAfterDiscount = 0;

      if (item.addon?.length && !isAbsorb) {
        const shouldCalculateUBMeForAddon = item.TicketType !== "Paid";

        const addonResult = calculateAddonFee({
          addonList: item.addon,
          discountData,
          ticketId: item.TicketId,
          isAbsorb,
          feePercent:  toNumber(item.UBMeFeePercent),
          additionalFee: shouldCalculateUBMeForAddon ? additionalFee : 0,
          quantity: ticketsWithPaidAddon, // use tickets with paid addon
        });

        obj.AddonOriginalTotal = addonResult.addonOriginalTotal;
        obj.AddonTotalAfterDiscount = addonResult.addonAfterDiscount;
        obj.DiscountAmount = round2(obj.DiscountAmount + addonResult.addonDiscountTotal);

        // Add UBMe fee only if free ticket
        // if (shouldCalculateUBMeForAddon) {
        obj.UBMeFeePercent = round2(obj.UBMeFeePercent + addonResult.addonFee);
        // }
      }

      /* ---------- TAX ---------- */

      obj.Tax = round2(
          (netTicketPrice +
              obj.AddonTotalAfterDiscount +
              obj.UBMeFeePercent) *
          taxPercent
      );

      /* ---------- CARD ADDITIONAL FEE ---------- */

      const ticketTotal =
          netTicketPrice +
          obj.AddonTotalAfterDiscount +
          obj.UBMeFeePercent +
          obj.Tax;

      let normalizedCardAdditionalFee = 0;

      if (ticketTotal > 0 && cardFeeAdditional > 0 && totalTicketCount > 0) {

        normalizedCardAdditionalFee =
            (cardFeeAdditional / totalTicketCount) *
            ubmeQuantity;

        normalizedCardAdditionalFee = round2(normalizedCardAdditionalFee);
      }

      obj.CardProcessingAdditionalFee = normalizedCardAdditionalFee;

      if (!(item.IsCardProcessingFeeAbsorb ?? false)) {
        cardFeeEligibleBase += ticketTotal;
        distributedCardAdditionalFee += normalizedCardAdditionalFee;
      }

      return obj;

    });

    const cardProcessingFee = round2(
        calculateCardProcessingFee({
          baseAmount: cardFeeEligibleBase,
          cardFeePercent,
          cardFeeAdditional: distributedCardAdditionalFee,
        })
    );

    setNewCartItems(CartItemsData);
    setCardProcessingFee(cardProcessingFee);

  }, [cartItems, discountData, shoppingCartDetails, selectedPaymentMethod]);

  /* =====================
   * TOTALS
   * ===================== */
  const subTotal = round2(
      newCartItems.reduce(
          (sum, c) =>
              sum +
              toNumber(c.OriginalTicketTotal) +
              toNumber(c.AddonOriginalTotal),
          0
      )
  );

  const discount = round2(
      newCartItems.reduce(
          (sum, c) => sum + toNumber(c.DiscountAmount),
          0
      )
  );

  const fee = round2(
      newCartItems.reduce(
          (sum, c) => sum + toNumber(c.UBMeFeePercent),
          0
      )
  );

  const tax = round2(
      newCartItems.reduce(
          (sum, c) => sum + toNumber(c.Tax),
          0
      )
  );

  const totalPriceWithCCFee = round2(
      subTotal - discount + fee + tax + cardProcessingFee
  );

  // inside Payment.js
  useEffect(() => {
    if (!selectedPaymentMethod) return;

    // prevent same method twice
    if (lastPersistedMethod.current === selectedPaymentMethod) return;

    // prevent overlapping calls
    if (isPersistingRef.current) return;

    lastPersistedMethod.current = selectedPaymentMethod;
    isPersistingRef.current = true;

    const persistCart = async () => {
      try {
        // let storeData = store.getState();
        // const persistData = storeData.eventReducer.persistShopingCart;

        const cartItemToUse = newCartItemsRef.current;
        const data = {
          ShoppingCart: {
            CartSession: {
              EventId: currentEventDetails?.EventId,
              SessionId: shoppingCartDetails?.CartSession.SessionId,
              DiscountId: discountData?.disCountId,
              UserId: results?.ProfileDetail?.UserId ?? null,
              Salt: "",
              ValidationCode: "",
              PaymentMethod: (selectedPaymentMethod !== null) ? selectedPaymentMethod : ""
            },
            CartItems: cartItemToUse.flatMap((cartItem) => {
              const {
                Quantity,
                TicketId,
                ItemId,
                RecurringTicket,
                selectedDate,
                selectedSlots,
                selectedSlot,
                isBundle,
                addon,
                GroupIds
              } = cartItem;

              const RecurringTicketValue =
                  RecurringTicket === "True" ? "true" : "false";

              if (isBundle) {
                // If it's a bundle, iterate through selectedSlots
                return selectedSlots.map((slot) => ({
                  Quantity,
                  TicketId,
                  ItemId: slot.ItemId,
                  RecurringTicket: RecurringTicketValue,
                  BookingDate: convertAndAdjustDatetime(
                      slot.date,
                      slot.StartTime
                  ),
                  BookingTime: slot.StartTime,
                  isBundle: isBundle ? 1 : 0,
                  AddOns: groupAddOns(addon,GroupIds)
                }));
              } else {
                // If it's not a bundle, return a single item
                return {
                  Quantity,
                  TicketId,
                  ItemId,
                  RecurringTicket: RecurringTicketValue,
                  BookingDate:
                      RecurringTicket === "True"
                          ? convertAndAdjustDatetime(
                              selectedDate,
                              selectedSlot?.StartTime
                          )
                          : "",
                  BookingTime:
                      RecurringTicket === "True" ? selectedSlot?.StartTime : "",
                  AddOns: groupAddOns(addon,GroupIds)
                };
              }
            }),
          },
        };

        dispatch(getPersistShopingCartData(data));

        const res = await dispatch(PersistShoppingCartSession(data));
        handlePersistCart(res, null);
      } catch (err) {
        handlePersistCart(null, err);
      } finally {
        isPersistingRef.current = false; // release lock
      }
    };

    void persistCart();
  }, [selectedPaymentMethod]);


  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

  // Define a function to handle phone number change
  const handlePhoneNumberChange = (
      value,
      country,
      ticketIndex = null,
      itemIndex = null,
      FormFieldId
  ) => {
    try {
      // Detect if the country has changed
      if (country.countryCode !== previousCountry) {
        setPreviousCountry(country.countryCode);
        setSelectedCountry(country.countryCode);
        setPhoneNumber(`${country.dialCode}`);
        setIsNotFilled(true);
        setPhoneError("");
        return;
      }

      // Remove all non-numeric characters from the value
      value = value.replace(/\D/g, "");

      const countryCode = `${country.dialCode}`;

      // Check if the value starts with the country's dial code
      if (!value.startsWith(countryCode)) {
        value = countryCode + value;
      }

      // Ensure the input value has a minimum length before parsing
      if (value.length >= 6) {
        const phoneNumberObject = parsePhoneNumberWithError(
            value,
            country.countryCode.toUpperCase()
        );
        if (phoneNumberObject && phoneNumberObject.isValid()) {
          // Valid phone number
          setIsNotFilled(false);
          setPhoneNumber(value);
          setPhoneError("");

          // Update the phone number in the correct field
          if (isMultiUserDetails) {
            // Multi-user case: Update the correct field in updatedAdditionalInfo
            let newData = [...updatedAdditionalInfo];
            const fieldKey = `${ticketIndex}-${itemIndex}-${FormFieldId}`;
            const foundField = newData.find((field) => field.key === fieldKey);

            if (foundField) {
              foundField.DefaultValue = value;
            }
            setUpdatedAdditionalInfo(newData);
          } else {
            // Single-user case: Update additionalInfo directly
            let newData = [...additionalInfo];
            const foundObject = newData.find(
                (item) => item.FieldName === "Phone"
            );
            if (foundObject) {
              foundObject.DefaultValue = value;
            }
            setAdditionalInfo(newData);
          }
        } else {
          // Invalid phone number
          setIsNotFilled(true);
          setPhoneError("Please enter a valid phone number.");
        }
      } else {
        // Input doesn't meet minimum length
        setIsNotFilled(true);
        setPhoneError("Please enter a valid phone number.");
      }

      // Check if selected country has changed
      if (selectedCountry !== country.countryCode) {
        setIsNotFilled(true);
        setPhoneError("Phone number is required.");
      }
    } catch (error) {
      if (error instanceof ParseError) {
        // Handle parsing error
        console.log(error.message);
      } else {
        throw error;
      }
    }
  };

  const getPlaceholder = (countryCode) => {
    const phoneNumber = "0000000000";
    const formattedNumber = libphonenumber.formatNumber(
        phoneNumber,
        countryCode,
        "INTERNATIONAL"
    );
    return formattedNumber;
  };

  const memoizedPlaceholder = useMemo(
      () =>
          getPlaceholder(selectedCountry ? selectedCountry.toUpperCase() : "US"),
      [selectedCountry]
  );

  useEffect(() => {
    //Find index of specific object using findIndex method.
    let objIndex = additionalInfo?.findIndex(
        (obj) => obj?.FieldName === "Terms And Conditions"
    );
    //Update object's name property.
    // if (objIndex > 0) {
    //   additionalInfo[objIndex].DefaultValue = isChecked;
    // }
  }, [isChecked]);

  const checkboxItem = additionalInfo.find(
      (x) => x.FieldName === "Terms And Conditions"
  );

  useEffect(() => {
    let hasInvalidFields = false;

    if (isMultiUserDetails) {
      // Multi-user details: Check for missing or invalid fields across all items
      hasInvalidFields = newCartItems.some((ticketItem, ticketIndex) =>
          Array.from({ length: ticketItem.Quantity }).some((_, itemIndex) =>
              updatedAdditionalInfo.some((field) => {
                const isEmpty =
                    field.ticketIndex === ticketIndex &&
                    field.itemIndex === itemIndex &&
                    field.FieldName !== "Terms And Conditions" &&
                    (field.FieldName === "Full Name" ||
                        field.FieldName === "Email" ||
                        field.FieldName === "Phone" ||
                        field.IsForAllTickets ||
                        field.AssociatedIds.includes(ticketItem.TicketId)) &&
                    field.RequiredField === "True" &&
                    ((field.FieldType === "Multi-Select" &&
                            field?.DefaultValue?.length === 0) ||
                        field.DefaultValue === "");
                const isInvalid =
                    (field.FieldName === "Full Name" ||
                        field.FieldName === "Email" ||
                        field.FieldName === "Phone") &&
                    field.ticketIndex === ticketIndex &&
                    field.itemIndex === itemIndex &&
                    field.IsValid === false;
                return isEmpty || isInvalid;
              })
          )
      );
    } else {
      // Single-user details: Original logic for single-ticket case
      hasInvalidFields = additionalInfo.some((i) => {
        if (i.FieldName === "Terms And Conditions" && i.DefaultValue === "") {
          return false; // Skip Terms and Conditions
        }
        if (
            (i.FieldName === "Full Name" ||
                i.FieldName === "Email" ||
                i.FieldName === "Phone" ||
                i.IsForAllTickets ||
                i.AssociatedIds.includes(newCartItems[0].TicketId)) &&
            i.RequiredField === "True"
        ) {
          if (i.FieldType === "Multi-Select" && i?.DefaultValue?.length === 0) {
            return true;
          } else if (i.DefaultValue === "") {
            return true;
          }
          return false; // Empty field
        }
        return false; // Valid field
      });

      if (!hasInvalidFields) {
        hasInvalidFields = additionalInfo.some(
            (i) =>
                (i.FieldName === "Full Name" || i.FieldName === "Email") &&
                i.IsValid === false
        );
      }
    }

    if (!hasInvalidFields && checkboxItem) {
      // Handle checkbox-specific validation
      hasInvalidFields =
          checkboxItem.DefaultValue !== "" && !isChecked ? true : false;
    }

    // Update state based on validation
    setIsNotFilled(hasInvalidFields);

    // Sync checkbox value for rendering
    if (checkboxItem) {
      setCheckBoxValue(checkboxItem.DefaultValue);
    }
  }, [
    isMultiUserDetails,
    updatedAdditionalInfo,
    additionalInfo,
    newCartItems,
    checkboxItem,
    isChecked,
  ]);

  useEffect(() => {
    let computedInfo = [];

    if (isMultiUserDetails) {
      // Generate fields for each ticket item and quantity
      computedInfo = newCartItems.flatMap((ticketItem, ticketIndex) =>
          Array.from({ length: ticketItem.Quantity }).flatMap((_, itemIndex) =>
              additionalInfo.map((field) => ({
                ...field,
                key: `${ticketIndex}-${itemIndex}-${field.FormFieldId}`, // Unique key
                ticketIndex, // Track ticket index
                itemIndex, // Track item index
                ItemId: ticketItem.ItemId,
              }))
          )
      );
    } else {
      // Generate fields for single user
      computedInfo = additionalInfo.map((field) => ({
        ...field,
        key: `${field.FormFieldId}`, // Unique key
      }));
    }

    setUpdatedAdditionalInfo((prev) => {
      const prevKeys = new Set(prev.map((item) => item.key));
      const newKeys = new Set(computedInfo.map((item) => item.key));

      // Only update if keys differ
      if (
          prevKeys.size === newKeys.size &&
          [...prevKeys].every((key) => newKeys.has(key))
      ) {
        console.log("No changes detected in updatedAdditionalInfo.");
        return prev;
      }

      console.log("Updating updatedAdditionalInfo.");
      return computedInfo;
    });
  }, [newCartItems, additionalInfo, isMultiUserDetails]);

  // console.log("additionalInfo",additionalInfo);
  let obj = {};
  const fieldData = {};

  const data = additionalInfo.map(
      ({ FieldName, DefaultValue, FieldType, Options }) => {
        const formattedFieldName = FieldName.replace(
            /\s/g,
            FieldName === "Full Name" ? "" : "_"
        );
        if(!fieldData.AddonGroupId && newCartItems.length>0){
          fieldData.AddonGroupId = newCartItems[0].GroupIds[0]
        }
        if (
            FieldType === "Multi-Select" ||
            FieldType === "Dropdown" ||
            FieldType === "Radio"
        ) {
          if (!fieldData.ExoticFields) {
            fieldData.ExoticFields = {};
          }

          fieldData.ExoticFields[formattedFieldName] = {
            SelectedValue: DefaultValue || "",
            FieldType: FieldType,
            Options: Options?.length > 0 ? JSON.parse(Options) : null,
          };
        } else {
          fieldData[formattedFieldName] = DefaultValue || "";
        }
      }
  );
  Object.assign(obj, fieldData);
  obj.Phone = obj?.Phone?.replace(/[^\d]+/g, "");
  if (obj.hasOwnProperty("TermsAndConditions")) {
    let specialChars =
        /[\\"/\#\$\%\&\(\)\*\+\,\-\.\:\;\<\=\>\?\@\[\]\^\`\{\|\}\~\'\!]/g;
    obj.TermsAndConditions = obj.TermsAndConditions.replace(
        specialChars,
        "\\$&"
    );
  }
  localStorage.setItem("additionalInfo", JSON.stringify(obj));

  const createPaymentIntent = async (additional) => {
    try {
      const payload = {
        EventId: currentEventDetails?.EventId,
        SessionId: shoppingCartDetails?.CartSession?.SessionId,
        PaymentIntentId: paymentIntent?.paymentId,
        OrderAdditionalData:
            currentEventDetails?.IsAnonymousAllowed === "False"
                ? null // Set to null if IsAnonymousAllowed is 'False'
                : additional
                    ? localStorage.getItem("additionalInfo")
                    : null,
        IsAnonymousAllowed: currentEventDetails?.IsAnonymousAllowed,
        CartItemsAdditionalData: null, // To be populated for multi-user
      };

      if (currentEventDetails?.IsAnonymousAllowed === "False") {
        const cartItemsToUse = newCartItemsRef.current; // always latest

        const cartItemsData = cartItemsToUse.flatMap((item) => {
          const quantity = item.Quantity;
          const groupIds = item.GroupIds;

          // Transform and group additional info
          const relevantAdditionalInfo = updatedAdditionalInfo.filter(
              (info) => info.ItemId === item.ItemId
          );
          const groupedAdditionalInfo = {};
          relevantAdditionalInfo.forEach((info) => {
            const index = info.itemIndex || 0;
            const formattedFieldName = info.FieldName.replace(
                /\s/g,
                info.FieldName === "Full Name" ? "" : "_"
            );

            if (!groupedAdditionalInfo[index]) {
              groupedAdditionalInfo[index] = {};
            }

            if(!groupedAdditionalInfo[index].AddonGroupId){
              groupedAdditionalInfo[index].AddonGroupId = groupIds[index]
            }

            if (
                info.FieldType &&
                (info.FieldType === "Multi-Select" ||
                    info.FieldType === "Dropdown" ||
                    info.FieldType === "Radio")
            ) {
              if (!groupedAdditionalInfo[index].ExoticFields) {
                groupedAdditionalInfo[index].ExoticFields = {};
              }

              groupedAdditionalInfo[index].ExoticFields[formattedFieldName] = {
                SelectedValue: info.DefaultValue || "",
                FieldType: info.FieldType,
                Options:
                    info.Options?.length > 0 ? JSON.parse(info.Options) : null,
              };
            } else {
              groupedAdditionalInfo[index][formattedFieldName] =
                  info.DefaultValue || "";
            }
          });
          const additionalDataArray = Object.values(groupedAdditionalInfo);

          const replicatedData = [];
          for (let i = 0; i < quantity; i++) {
            const dataIndex = i % additionalDataArray.length;
            replicatedData.push(additionalDataArray[dataIndex]);
          }

          if (item.isBundle) {
            // If it's a bundle, iterate through selectedSlots
            return item.selectedSlots.map((slot) => ({
              ItemId: slot.ItemId,
              AdditionalData: JSON.stringify(replicatedData),
            }));
          } else {
            return [{
              ItemId: item.ItemId,
              AdditionalData: JSON.stringify(replicatedData),
            }];
          }

        });

        // Assign the constructed CartItemsAdditionalData to payload
        payload.CartItemsAdditionalData = cartItemsData;
      }

      const payloadToBeSent = {
        OrderDataPaymentIntent: payload,
      };
      const { data } = await axiosE.post(
          "CreatePaymentIntent",
          payloadToBeSent
      );

      setClientSecret(data.results.ClientSecret);
      dispatch({
        type: "PAYMENT_INTENT_DETAILS",
        payload: {
          PublicKey: data.results.PublicKey,
          paymentId: data.results.Id,
        },
      });

      localStorage.setItem("public_key", data.results.PublicKey);
      setPublicKey(data.results.PublicKey);

      let returnUrlWithParams = null;
      if (isEmbed) {
        const emailDefaultValue =
            additionalInfo?.find(item => item.FieldName === "Email")?.DefaultValue || "";

        // ✅ Build return_url with query params here
        const searchParams = new URLSearchParams();
        searchParams.set("sessionId", shoppingCartDetails?.CartSession?.SessionId || "");
        searchParams.set("ticketQty", cartItems?.reduce((a, c) => a + Number(c.Quantity), 0) || 0);
        searchParams.set("isRecurring", cartItems?.some(x => x.RecurringTicket === "True" || x.RecurringTicket === "true") || false);
        searchParams.set("email", emailDefaultValue);
        searchParams.set("embed", isEmbed ? "true" : "false");
        searchParams.set("eventId", currentEventDetails?.EventId || "");
        searchParams.set("title", currentEventDetails?.Title || "");
        searchParams.set("start", currentEventDetails?.StartDateTime || "");
        searchParams.set("end", currentEventDetails?.EndDateTime || "");
        searchParams.set("address", currentEventDetails?.Add1 || "");

        returnUrlWithParams = `${window.location.origin}${routeName}/success/?${searchParams.toString()}`;

        // setReturnUrl(returnUrlWithParams); // store in state to use in PaymentForm
      }

      setLoading(false);

      // return it so caller has the latest URL
      return returnUrlWithParams;
    } catch (error) {
      console.error("Error creating payment intent:", error);
      setLoading(false);
    }
  };

  const appearance = {
    theme: "stripe",
  };

  const options = {
    clientSecret,
    appearance,
  };

  // useEffect(() => {
  //   if (minutes === 0 && seconds === 0) {
  //     console.log("Time Out", minutes, seconds);
  //     // setContinueToCheckOut(false)
  //   }
  // }, [minutes, seconds]);

  const clearCartItem = () => {
    dispatch(ticktesCartItem([]));
  };

  const handleChange = (
      e,
      ticketIndex = null,
      itemIndex = null,
      isMultiUser = true,
      multiselect = false
  ) => {
    const { name, value } = e.target;

    const fieldKey = isMultiUser ? `${ticketIndex}-${itemIndex}-${name}` : name; // Use only the field name for single-user mode
    if (isMultiUser) {
      // Handle multi-user case (updates updatedAdditionalInfo)
      setUpdatedAdditionalInfo((prev) => {
        const newData = [...prev];
        const fieldIndex = newData.findIndex((field) => field.key === fieldKey);

        if (fieldIndex !== -1) {
          // Update existing field
          if (multiselect) {
            if (!Array.isArray(newData[fieldIndex].DefaultValue)) {
              newData[fieldIndex].DefaultValue = [];
            }
            if (newData[fieldIndex].DefaultValue.includes(value)) {
              newData[fieldIndex].DefaultValue = newData[
                  fieldIndex
                  ].DefaultValue.filter((item) => item !== value);
            } else {
              newData[fieldIndex] = {
                ...newData[fieldIndex],
                DefaultValue: [...newData[fieldIndex].DefaultValue, value],
              };
            }
          } else {
            newData[fieldIndex] = {
              ...newData[fieldIndex],
              DefaultValue: value,
            };
          }
        } else {
          // Add new multi-user field
          newData.push({
            key: fieldKey,
            FieldName: name,
            DefaultValue: multiselect ? [value] : value,
            IsValid: true,
            ErrorMessage: "",
            ticketIndex,
            itemIndex,
          });
        }

        return newData;
      });
    } else {
      // Handle single-user case (updates additionalData)
      setAdditionalInfo((prev) => {
        const newData = [...prev];
        const fieldIndex = newData.findIndex(
            (field) => field.FormFieldId === name
        );

        if (fieldIndex !== -1) {
          if (multiselect) {
            if (!Array.isArray(newData[fieldIndex].DefaultValue)) {
              newData[fieldIndex].DefaultValue = [];
            }
            if (newData[fieldIndex].DefaultValue.includes(value)) {
              newData[fieldIndex].DefaultValue = newData[
                  fieldIndex
                  ].DefaultValue.filter((item) => item !== value);
            } else {
              newData[fieldIndex] = {
                ...newData[fieldIndex],
                DefaultValue: [...newData[fieldIndex].DefaultValue, value],
              };
            }
          } else {
            newData[fieldIndex] = {
              ...newData[fieldIndex],
              DefaultValue: value,
            };
          }
        } else {
          // Add new single-user field
          newData.push({
            key: name, // Single-user key is just the name
            FieldName: name,
            DefaultValue: multiselect ? [value] : value,
            IsValid: true,
            ErrorMessage: "",
          });
        }

        return newData;
      });
    }
  };

  const updateFieldData = (fieldData, name, value) => {
    // Add validation logic here
    if (name === "Full Name") {
      const isValid = /^(?=.*[A-Za-z])[\w\s'-]+ [A-Za-z\d\s'-]+$/.test(value);
      fieldData.IsValid = isValid;
      fieldData.ErrorMessage = isValid
          ? ""
          : "Please enter a valid first and last name.";
    } else if (name === "Email") {
      const isValid = /\S+@\S+\.\S+/.test(value);
      fieldData.IsValid = isValid;
      fieldData.ErrorMessage = isValid
          ? ""
          : "Please enter a valid email address.";
    }

    // Update the field data
    fieldData.DefaultValue = value;
  };

  const handlePersistCart = (response, error) => {
    if (response) {
      // Response handling logic
      if (
          response.CartSession.Total === null ||
          Number(response.CartSession.Total) === 0
      ) {
        setClientSecret("");
        setPublicKey("");
        setIsFreeTicket(true);
        setLoading(false);
      } else {
        createPaymentIntent(false)
            .then((/* handle the response from createPaymentIntent */) => {
              // Update the isFreeTicket state to false
              setIsFreeTicket(false);

              // Refresh the Payment Element after updating Payment Intent
              setTimeout(() => {
                if (checkoutFormRef.current) {
                  checkoutFormRef.current.refreshPaymentElement();
                }
              }, 500);
            })
            .catch((err) => {
              // Handle errors from createPaymentIntent if needed
            });
      }
    } else if (error) {
      // Error handling logic
      ErrorInPersist();
    }
  };

  const ErrorInPersist = () => {
    console.log("ErrorInPersist");
    const data = {
      DiscountType: "",
      disCountAmount: 0.0,
      disCountId: "",
      TicketsId: [],
      RemainingUtilization: "",
      ResponseCode: false,
      DiscountCode: "",
    };
    dispatch({ type: "REMAINING_UTILIZATION", payload: null });
    // if DiscountType is Percentage
    dispatch(GetDiscountData(data));
    dispatch(ticktesCartItem([]));
    dispatch({
      type: "PAYMENT_INTENT_DETAILS",
      payload: { PublicKey: null, paymentId: null },
    });
    dispatch({
      type: "START_TIMMER",
      payload: false,
    });
    // For restart cartSession
    try {
      axiosE
          .post("ShoppingCart/Delete", {
            SessionId: shoppingCartDetails?.CartSession?.SessionId,
          })
          .then(() => {
            dispatch({ type: "CREATE_SHOPPING_DETAILS", payload: null });
            setContinueToCheckOut(false);
          })
          .catch(() => {});
    } catch (error) {}
  };

  const OrderAdditionalData = () => {
    dispatch(GetAllOrderFormFieldsByEventId(currentEventDetails?.EventId))
        .then((data) => {
          if (data.results.ResponseCode) {
            const defaultAdditionalData = data.results.ListOrderFormField.map(
                (item) => {
                  const obj = Object.assign({}, item);
                  if (
                      item.FieldName === "Full Name" &&
                      results?.ProfileDetail?.FirstName !== null
                  ) {
                    obj["DefaultValue"] = results?.ProfileDetail?.FirstName;
                  }
                  if (
                      item.FieldName === "Email" &&
                      results?.ProfileDetail?.Email !== null
                  ) {
                    obj["DefaultValue"] = results?.ProfileDetail?.Email;
                  }
                  if (
                      item.FieldName === "Phone" &&
                      results?.ProfileDetail?.PhoneNumber !== null
                  ) {
                    let fomatedNumber = "";
                    if (results?.ProfileDetail?.PhoneNumber) {
                      //     let cleaned =
                      //       "" + results?.ProfileDetail?.PhoneNumber.replace(/\D/g, "");
                      //     for (let index = 0; index < cleaned.length; index++) {
                      //       if (index == 0) {
                      //         fomatedNumber = "(";
                      //       } else if (index == 3) {
                      //         fomatedNumber = fomatedNumber + ") ";
                      //       } else if (index == 6) {
                      //         fomatedNumber = fomatedNumber + "-";
                      //       }
                      //       fomatedNumber = fomatedNumber + cleaned[index];
                      //     }
                      fomatedNumber = results?.ProfileDetail?.PhoneNumber;
                    }
                    obj["DefaultValue"] = fomatedNumber;
                  }
                  console.log("$$$$$$$$", obj, results?.ProfileDetail?.PhoneNumber);
                  return obj;
                }
            );

            const orderedData = [
              // Full Name first
              ...defaultAdditionalData.filter(
                  (field) => field.FieldName === "Full Name"
              ),
              // Then Email
              ...defaultAdditionalData.filter(
                  (field) => field.FieldName === "Email"
              ),
              // Then Phone
              ...defaultAdditionalData.filter(
                  (field) => field.FieldName === "Phone"
              ),
              // The rest of the fields in original order
              ...defaultAdditionalData.filter(
                  (field) =>
                      !["Full Name", "Email", "Phone"].includes(field.FieldName)
              ),
            ];

            setAdditionalInfo(orderedData);
          }
        })
        .catch(() => {});
  };

  const convertAndAdjustDatetime = (utcDate, utcTime) => {
    const targetTimezone = JSON.parse(localStorage.getItem("CurrentTimeZone"));
    // if (targetTimezone === "Asia/Kolkata") {
    const isItMomentObject =
        utcDate &&
        typeof utcDate === "object" &&
        typeof utcDate.format === "function";
    const selectedDate = isItMomentObject
        ? utcDate.format("DD/MM/YYYY")
        : utcDate;
    const utcDateTime = momentTz.utc(
        `${selectedDate} ${utcTime}`,
        "DD/MM/YYYY HH:mm:ss"
    );
    const convertedDateTime = momentTz.tz(utcDateTime, targetTimezone);

    if (convertedDateTime.date() > utcDateTime.date()) {
      const revertedDateTime = momentTz
          .tz(utcDateTime, "UTC")
          .subtract(1, "day");
      return revertedDateTime.format("MM/DD/YYYY");
    } else if (convertedDateTime.date() < utcDateTime.date()) {
      const revertedDateTime = momentTz.tz(utcDateTime, "UTC").add(1, "day");
      return revertedDateTime.format("MM/DD/YYYY");
    }

    return convertedDateTime.format("MM/DD/YYYY");
    // }

    // return moment(utcDate, "DD/MM/YYYY").format("MM/DD/YYYY");
  };

  const sortSelectedSlots = (item) => {
    if (item.selectedSlots) {
      item.selectedSlots.sort((a, b) => {
        // Convert date strings to JavaScript Date objects for comparison
        const dateA = parseDate(a.date, a.StartTime);
        const dateB = parseDate(b.date, b.StartTime);

        // Compare dates
        if (dateA < dateB) {
          return -1;
        } else if (dateA > dateB) {
          return 1;
        } else {
          // If dates are equal, compare start times
          const timeA = parseInt(a.StartTime.replace(":", ""));
          const timeB = parseInt(b.StartTime.replace(":", ""));

          return timeA - timeB;
        }
      });
    }
  };

  function groupAddOns(addonList, GroupIds) {
    const grouped = {};

    addonList.forEach((addon) => {
      const person = addon.person;
      if (!grouped[person]) grouped[person] = new Set();
      grouped[person].add(addon.AddOnId);
    });

    const addOnGroups = [];

    GroupIds.forEach((groupId, index) => {
      const person = index + 1;
      const addonIds = grouped[person] ? Array.from(grouped[person]) : [];
      addOnGroups.push({
        AddOnIdList: addonIds,
        GroupID: groupId
      });
    });

    return addOnGroups;
  }

  // Parse date in DD/MM/YYYY format and time in HH:mm format
  const parseDate = (date, time) => {
    const [day, month, year] = date.split("/");
    const hours = time ? parseInt(time.split(":")[0]) : 0;
    const minutes = time ? parseInt(time.split(":")[1]) : 0;
    // Months are zero-based in JavaScript Date, so we subtract 1 from the month
    return new Date(year, month - 1, day, hours, minutes);
  };

  const getSlotUtcDate = (slotDate, slotStartTime, userTimezone) => {
    // Parse local date
    const [day, month, year] = slotDate.split("/").map(Number);

    // Parse UTC time
    const [hourUTC, minuteUTC] = slotStartTime.split(":").map(Number);

    // Step 1: Create a moment for the slot date at 00:00 in user's timezone
    const localMidnight = moment.tz({ year, month: month - 1, day, hour: 0, minute: 0 }, userTimezone);

    // Step 2: Create a UTC datetime using slotStartTime
    let slotUtc = moment.utc({
      year,
      month: month - 1,
      day,
      hour: hourUTC,
      minute: minuteUTC,
    });

    // Step 3: If UTC time is before local midnight in UTC, shift to next day
    if (slotUtc.isBefore(localMidnight.clone().utc())) {
      slotUtc.add(1, "day");
    }

    return slotUtc.format("DD/MM/YYYY");
  };

  const updateCartItems = (updatedCartItems) => {
    // Update state for UI
    setNewCartItems(updatedCartItems);

    // Update ref immediately for any function that reads latest cart items
    newCartItemsRef.current = updatedCartItems;
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      // if (results?.ProfileDetail?.UserId) {
      setLoading(true);
      cartItems.forEach((item) => sortSelectedSlots(item));
      const data = {
        ShoppingCart: {
          CartSession: {
            EventId: currentEventDetails?.EventId,
            SessionId: shoppingCartDetails?.CartSession.SessionId,
            DiscountId: discountData?.disCountId,
            UserId: results?.ProfileDetail?.UserId ?? null,
            Salt: "",
            ValidationCode: "",
            PaymentMethod: (selectedPaymentMethod !== null) ? selectedPaymentMethod : ""
          },
          CartItems: cartItems.flatMap((cartItem) => {
            const {
              Quantity,
              TicketId,
              ItemId,
              RecurringTicket,
              selectedDate,
              selectedSlots,
              selectedSlot,
              isBundle,
              addon,
              GroupIds
            } = cartItem;

            const RecurringTicketValue =
                RecurringTicket === "True" ? "true" : "false";

            if (isBundle) {
              // If it's a bundle, iterate through selectedSlots
              return selectedSlots.map((slot) => ({
                Quantity,
                TicketId,
                // ItemId: slot.ItemId,
                RecurringTicket: RecurringTicketValue,
                BookingDate: convertAndAdjustDatetime(
                    slot.date,
                    slot.StartTime
                ),
                BookingTime: slot.StartTime,
                isBundle: isBundle ? 1 : 0,
                AddOns: groupAddOns(addon,GroupIds)
              }));
            } else {
              // If it's not a bundle, return a single item
              return {
                Quantity,
                TicketId,
                ItemId,
                RecurringTicket: RecurringTicketValue,
                BookingDate:
                    RecurringTicket === "True"
                        ? convertAndAdjustDatetime(
                            selectedDate,
                            selectedSlot?.StartTime
                        )
                        : "",
                BookingTime:
                    RecurringTicket === "True" ? selectedSlot?.StartTime : "",
                AddOns: groupAddOns(addon,GroupIds)
              };
            }
          }),
        },
      };

      dispatch(getPersistShopingCartData(data));

      if (cartItems?.length > 0) {
        setTimeout(() => {
          dispatch(PersistShoppingCartSession(data))
              .then((res) => {
                if (res.ResponseCode) {
                  localStorage.setItem(
                      "CurrentSessionId",
                      JSON.stringify(res.CartSession.SessionId)
                  );
                  setDiscountCodeExist(res.CartSession.DiscountExist);
                  if (res?.CartItems?.every((e) => e.ResponseCode === true)) {
                    // Update the existing array in place
                    const updatedCartItems = cartItems.map((item) => {
                      let updatedSelectedSlots;

                      if (item.selectedSlots !== undefined) {

                        updatedSelectedSlots = item.selectedSlots.map(slot => {
                          const slotUtcDate = getSlotUtcDate(slot.date, slot.StartTime, "America/Toronto");

                          const matchingCartItem = res?.CartItems?.find(
                              cartItem =>
                                  moment.utc(cartItem.BookingDate).format("DD/MM/YYYY") === slotUtcDate &&
                                  cartItem.BookingTime === slot.StartTime
                          );

                          if (matchingCartItem) {
                            return {
                              ...slot,
                              ItemId: matchingCartItem.ItemId,
                            };
                          }

                          return slot;
                        });
                      }

                      return {
                        ...item,
                        ...(updatedSelectedSlots && {
                          selectedSlots: updatedSelectedSlots,
                        }),
                      };
                    });

                    updateCartItems(updatedCartItems);

                    OrderAdditionalData();
                    dispatch({
                      type: "START_TIMMER",
                      payload: true,
                    });

                    if (
                        res.CartSession.Total === null ||
                        Number(res.CartSession.Total) === 0
                    ) {
                      setIsFreeTicket(true);
                      setLoading(false);
                    } else {
                      createPaymentIntent(false);
                    }
                  } else {
                    ErrorInPersist();
                  }
                } else {
                  ErrorInPersist();
                }
              })
              .catch((e) => {
                console.log(e);
              });
        }, 1000);
      }
      // }
    }
    return () => {
      isMounted = false;
    };
  }, []);

  const PersistFreeOrder = () => {
    // localStorage.setItem("additionalInfo", JSON.stringify(obj))
    newCartItems.forEach((item) => sortSelectedSlots(item));

    const data = {
      ShoppingCart: {
        CartItems: newCartItems.flatMap(
            ({
               Quantity,
               TicketId,
               ItemId,
               RecurringTicket,
               selectedDate,
               selectedSlot,
               selectedSlots,
               isBundle,
               GroupIds
             }) => {
              const RecurringTicketValue =
                  RecurringTicket === "True" ? "true" : "false";

              const replicatedData = [];
              if (currentEventDetails?.IsAnonymousAllowed === "False") {
                // Filter all additional info for this item by matching ItemId
                const relevantAdditionalInfo = updatedAdditionalInfo.filter(
                    (info) => info.ItemId === ItemId
                );
                // Group relevantAdditionalInfo by itemIndex to handle multiple sets of data
                const groupedAdditionalInfo = {};

                relevantAdditionalInfo.forEach((info) => {
                  const index = info.itemIndex || 0;
                  const formattedFieldName = info.FieldName.replace(
                      /\s/g,
                      info.FieldName === "Full Name" ? "" : "_"
                  );
                  if (!groupedAdditionalInfo[index]) {
                    groupedAdditionalInfo[index] = {};
                  }

                  if(!groupedAdditionalInfo[index].AddonGroupId){
                    groupedAdditionalInfo[index].AddonGroupId = GroupIds[index]
                  }

                  if (
                      info.FieldType &&
                      (info.FieldType === "Multi-Select" ||
                          info.FieldType === "Dropdown" ||
                          info.FieldType === "Radio")
                  ) {
                    if (!groupedAdditionalInfo[index].ExoticFields) {
                      groupedAdditionalInfo[index].ExoticFields = {};
                    }


                    groupedAdditionalInfo[index].ExoticFields[
                        formattedFieldName
                        ] = {
                      SelectedValue: info.DefaultValue || "",
                      FieldType: info.FieldType,
                      Options:
                          info.Options?.length > 0
                              ? JSON.parse(info.Options)
                              : null,
                    };
                  } else {
                    groupedAdditionalInfo[index][formattedFieldName] =
                        info.DefaultValue || "";
                  }
                });
                // Convert grouped data into an array of JSON objects
                const additionalDataArray = Object.values(groupedAdditionalInfo);

                // Ensure that the `AdditionalData` matches the quantity of tickets
                for (let i = 0; i < Quantity; i++) {
                  const dataIndex = i % additionalDataArray.length; // Cycle through available data if quantity exceeds unique entries
                  replicatedData.push(additionalDataArray[dataIndex]);
                }
              }

              if (isBundle) {
                // If it's a bundle, iterate through selectedSlots
                return selectedSlots.map((slot) => ({
                  Quantity,
                  TicketId,
                  ItemId: slot.ItemId,
                  RecurringTicket: RecurringTicketValue,
                  BookingDate: convertAndAdjustDatetime(
                      slot.date,
                      slot.StartTime
                  ),
                  BookingTime: slot.StartTime,
                  isBundle: isBundle ? 1 : 0,
                  OrderAdditionalData: JSON.stringify(replicatedData),
                }));
              } else {
                return {
                  Quantity,
                  TicketId,
                  ItemId,
                  RecurringTicket: RecurringTicketValue,
                  BookingDate:
                      RecurringTicket === "True"
                          ? convertAndAdjustDatetime(
                              selectedDate,
                              selectedSlot?.StartTime
                          )
                          : "",
                  BookingTime:
                      RecurringTicket === "True" ? selectedSlot?.StartTime : "",
                  OrderAdditionalData: JSON.stringify(replicatedData),
                };
              }
            }
        ),
        CartSession: {
          EventId: currentEventDetails?.EventId,
          SessionId: shoppingCartDetails?.CartSession.SessionId,
          DiscountId: discountData?.disCountId,
          UserId: results?.ProfileDetail?.UserId ?? null,
          OrderAdditionalData:
              currentEventDetails?.IsAnonymousAllowed === "False"
                  ? ""
                  : localStorage.getItem("additionalInfo"),
          IsAnonymousAllowed:
              currentEventDetails?.IsAnonymousAllowed === "False" ? 0 : 1,
        },
      },
    };
    // if (cartItems?.length > 0) {
    axiosE
        .post("PersistFreeOrder", data)
        .then(({ data }) => {
          if (data.results.ResponseCode) {
            const successUrl = `${routeName}/success`;

            if (isEmbed) {
              // Open in parent (full screen)
              const params = new URLSearchParams({
                embed: "true",
                eventId: currentEventDetails.EventId,
                title: currentEventDetails.Title,
                start: currentEventDetails.StartDateTime,
                end: currentEventDetails.EndDateTime,
                address: currentEventDetails.Add1,
                sessionId: shoppingCartDetails?.CartSession?.SessionId,
                ticketQty: cartItems?.reduce((a, c) => a + Number(c.Quantity), 0),
                isRecurring: cartItems?.some(
                    (x) => x.RecurringTicket === "True" || x.RecurringTicket === "true"
                ),
                email: JSON.parse(localStorage.getItem("additionalInfo"))?.Email,
              });

              window.top.location.href = `${successUrl}?${params.toString()}`;

              // history.push(successUrl + "?" + searchParams);
            } else {
              // Normal redirect in same window
              history.push(successUrl);
            }
          }
          setFreeBtndisabled(false);
        })
        .catch((e) => {
          setFreeBtndisabled(false);
          console.log(e);
        });
    // }
  };
  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }
  const [width, height] = useWindowSize();
  // For sorting additional fields
  if (additionalInfo.length > 0) {
    ["Phone", "Email", "Full Name"].map((item) => {
      const index = additionalInfo?.findIndex((object) => {
        return object?.FieldName === item;
      });
      const toIndex = 0;
    });
  }

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank");
    newWindow.opener = null;
  };

  const eventDateDetails = (ticket) => {
    if (ticket) {
      if (
          ticket.isBundle &&
          ticket?.selectedSlots !== undefined &&
          ticket?.selectedSlots !== null
      ) {
        const formattedDateTimeStrings = ticket?.selectedSlots.map((item) => {
          return `${formatDate(item.date)}, ${convertTo12HourFormat(
              item.StartTime,
              ticket
          )} - ${formatDate(item.date)}, ${convertTo12HourFormat(
              item.EndTime,
              ticket
          )}`;
        });

        const formattedDateTime = formattedDateTimeStrings.join("\n");

        return formattedDateTime;
      } else {
        return `${formatDate(ticket?.selectedDate)}, ${convertTo12HourFormat(
            ticket?.selectedSlot?.StartTime,
            ticket
        )} - ${formatDate(ticket?.selectedDate)}, ${convertTo12HourFormat(
            ticket?.selectedSlot?.EndTime,
            ticket
        )}`;
      }
    }
  };

  const formatDate = (dateString) => {
    const parsedDate = dayjs(dateString, "DD/MM/YYYY");
    const formattedDate = parsedDate.format("ddd, MMM D YYYY");
    return formattedDate;
  };

  const convertTo12HourFormat = (time, ticket) => {
    // console.log({ time, ticket });
    const isItMomentObject =
        ticket?.selectedDate &&
        typeof ticket.selectedDate === "object" &&
        typeof ticket.selectedDate.format === "function";
    const selectedDate = isItMomentObject
        ? ticket?.selectedDate.format("DD/MM/YYYY")
        : ticket?.selectedDate;

    const timeZone = JSON.parse(localStorage.getItem("CurrentTimeZone"));
    const dateTimeString = `${selectedDate} ${time}`;
    const utcDateTime = moment.utc(dateTimeString, "DD/MM/YYYY HH:mm");
    const istDateTime = utcDateTime?.tz(timeZone);
    const istLocalTime = istDateTime?.format("h:mm A");
    return istLocalTime;
  };

  const titleWithToolTip = (title, tipText, mandatory = false) => {
    return (
        <span style={{ fontSize: 16 }}>
        {title}
          {mandatory && <span style={{ color: "red" }}> *</span>}
          <CreateEventDetailsAboutToolTip
              title={<React.Fragment>{tipText}</React.Fragment>}
          >
          <span
              style={{
                padding: "0 0 0 10px",
                cursor: "pointer",
                color: "rgb(161, 3, 150)",
              }}
          >
            <Info style={{ fontSize: 20 }} />
          </span>
        </CreateEventDetailsAboutToolTip>
      </span>
    );
  };

  useEffect(() => {
    if (discountData.ResponseCode) {
      ApplyPromoCode(discountData.DiscountCode);
    }
  }, []);

  const ApplyPromoCode = (code) => {
    return new Promise(async (resolve, reject) => {
      setAppliedCode("");
      if (code) {
        try {
          let storeData = store.getState();
          const data = await dispatch(
              GetDiscountDetails(currentEventDetails?.EventId, code)
          );

          if (data.results.Message === "Valid discount code found") {
            const persistData = storeData.eventReducer.persistShopingCart;
            persistData.ShoppingCart.CartSession.DiscountId =
                data.results.DiscountId;

            // After PersistShoppingCartSession completes, resolve the promise with the response
            try {
              const res = await dispatch(
                  PersistShoppingCartSession(persistData)
              );
              handlePersistCart(res, null);
            } catch (err) {
              // Handle errors
              // You can also pass an error to the callback if needed
              handlePersistCart(null, err);
            }

            setDiscountError("");
            const discountData = {
              DiscountType: data.results.DiscountType,
              disCountAmount: data.results.DiscountAmount,
              disCountId: data.results.DiscountId,
              TicketsId: data.results.TicketsId.replace(/ /g, "").split(","),
              RemainingUtilization: data.results.RemainingUtilization,
              ResponseCode: data.results.ResponseCode,
              DiscountCode: code,
            };
            if (
                newCartItems?.some((id) =>
                    discountData?.TicketsId?.includes(id.TicketId)
                )
            ) {
              setAppliedCode(`${promoCode} Applied`);
            } else {
              setAppliedCode("Discount is not applicable for this ticket");
            }

            dispatch(GetDiscountData(discountData));
            setIsPromoCode(true);
          } else if (data.results.DiscountId && !data.results.ResponseCode) {
            setDiscountError(data.results.Message);
          } else {
            // setIsPromoCode(false)
            setAppliedCode("");
            setDiscountError("Sorry, your promotion code is invalid");
            if (discount > 0) {
              const data = {
                DiscountType: "",
                disCountAmount: 0.0,
                disCountId: "",
                TicketsId: [],
                RemainingUtilization: "",
                ResponseCode: false,
                DiscountCode: "",
              };
              dispatch(GetDiscountData(data));
            }
          }
        } catch (error) {
          reject(error);
        }
      } else {
        let storeData = store.getState();
        const persistData = storeData.eventReducer.persistShopingCart;
        persistData.ShoppingCart.CartSession.DiscountId = "";
        console.log({ persistData });

        // After PersistShoppingCartSession completes, resolve the promise with the response
        try {
          const res = await dispatch(PersistShoppingCartSession(persistData));
          handlePersistCart(res, null);
        } catch (err) {
          // Handle errors
          // You can also pass an error to the callback if needed
          handlePersistCart(null, err);
        }

        setIsPromoCode(!isPromoCode);
        resolve(); // Resolve the promise without a response when there's no code
      }
    });
  };

  const CreateEventDetailsAboutToolTip = withStyles(() => ({
    tooltip: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: "16px",
      border: "1px solid #dadde9",
    },
  }))(Tooltip);

  const searchParams = new URLSearchParams(window.location.search);
  const isEmbed = searchParams.get("embed") === "true";

  return (
      <>
        {localStorage.getItem("payment") === "success" ? (
            history.replace(`${routeName}/event/${currentEventDetails.EventId}`)
        ) : minutes === 0 && seconds === 0 ? (
            <TimeOutScreen
                setMinutes={setMinutes}
                setOpenCheckOut={setOpenCheckOut}
                setContinueToCheckOut={setContinueToCheckOut}
                hasCheckoutQuery={hasCheckoutQuery}
            />
        ) : leaveCheckOut ? (
            <Success
                setOpenCheckOut={setOpenCheckOut}
                setLeaveCheckOut={setLeaveCheckOut}
            />
        ) : (
            <React.Fragment>
              {loading ? (
                  <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                  >
                    <CircularProgress size={50} color="secondary" />
                  </div>
              ) : (
                  <div className="payment-container">
                    <div
                        class={` checkout-container ${
                            isFreeTicket ? "" : "checkout-container-paid"
                        }`}
                    >
                      <div class="main-heading">
                  <span className="main-heading-back">
                    {" "}
                    <IoArrowBack
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setContinueToCheckOut(false);
                          dispatch(clearCartSessionDiscountId());
                          const data = {
                            DiscountType: "",
                            disCountAmount: 0.0,
                            disCountId: "",
                            TicketsId: [],
                            RemainingUtilization: "",
                            ResponseCode: false,
                            DiscountCode: "",
                          };
                          dispatch(GetDiscountData(data));

                          let storeData = store.getState();
                        }}
                        size={25}
                    />
                  </span>
                        <h3>{constants.Text.Checkout}</h3>

                        {
                          <small>
                            {constants.Text.TimeLeft}{" "}
                            {minutes < 10 ? `0${minutes}` : minutes}:
                            {seconds < 10 ? `0${seconds}` : seconds}
                          </small>
                        }
                        {width <= 800 && !Token && !hasCheckoutQuery ? (
                            <div
                                onClick={() => setLeaveCheckOut(true)}
                                className="order_close"
                                style={{ top: 16 }}
                            >
                              <IoClose size={20} />
                            </div>
                        ) : null}

                        {/* <small>{timeBetween.minutes()}:{timeBetween.seconds()}</small> */}
                      </div>
                      <main
                          className="payment_main"
                          style={{
                            height: isFreeTicket ? "77%" : width > 800 ? "90%" : "100%",
                          }}
                      >
                        <div class="main-card">
                          <div class="info">
                            <p style={{ textAlign: "left" }}>
                              {constants.Text.ClickingPlaceOrder}
                              <a
                                  style={{ color: "#1894ff" }}
                                  target="_blank"
                                  href={`${routeName}/terms`}
                              >
                                {" "}
                                {constants.Text.TermsOfService}{" "}
                              </a>
                            </p>
                          </div>
                          {updatedAdditionalInfo.length > 0 && (
                              <div>
                                <div className="additional-information">
                                  <h1>{constants.Text.AdditionalInformation}</h1>
                                  <p>
                                    {constants.Text.AdditionalTermsDesc}
                                    <b
                                        style={{
                                          color: "rgb(244, 67, 54)",
                                          fontWeight: "600",
                                        }}
                                    >
                                      {constants.Text.AllFieldsMustBeFilledOut}
                                    </b>
                                  </p>
                                  {!isEmbed && !isLoggedIn && (
                                      <p style={{ marginTop: "16px" }}>
                                <span
                                    onClick={() => setIsNotLoggedIn(true)}
                                    style={{
                                      color: "#1976d2",
                                      textDecoration: "underline",
                                      fontWeight: "500",
                                      cursor: "pointer",
                                    }}
                                >
                                  Log in or sign up
                                </span>{" "}
                                        for a faster experience.
                                      </p>
                                  )}
                                </div>

                                {isMultiUserDetails ? (
                                    <div>
                                      {(() => {
                                        let overallIndex = 0; // Initialize the index counter

                                        return newCartItems.flatMap(
                                            (ticketItem, ticketIndex) =>
                                                Array.from({
                                                  length: ticketItem.Quantity,
                                                }).map((_, itemIndex) => {
                                                  overallIndex++; // Increment for each iteration
                                                  // Calculate a unique key for each item
                                                  const uniqueKey = `${ticketIndex}-${itemIndex}`;

                                                  return (
                                                      <div key={uniqueKey}>
                                                        <h3 style={{ marginBottom: "10px" }}>
                                                          {`Registration ${overallIndex} - ${ticketItem.Title}`}
                                                        </h3>
                                                        <div className="input-group">
                                                          {updatedAdditionalInfo
                                                              .filter(
                                                                  (field) =>
                                                                      field.ticketIndex === ticketIndex &&
                                                                      field.itemIndex === itemIndex &&
                                                                      (field.FieldName ===
                                                                          "Full Name" ||
                                                                          field.FieldName === "Email" ||
                                                                          field.FieldName === "Phone" ||
                                                                          field.IsForAllTickets ||
                                                                          field.AssociatedIds.includes(
                                                                              ticketItem.TicketId
                                                                          ))
                                                              )
                                                              .map(
                                                                  ({
                                                                     FieldName,
                                                                     FormFieldId,
                                                                     FieldType,
                                                                     DefaultValue,
                                                                     key,
                                                                     IsValid,
                                                                     ErrorMessage,
                                                                     Options,
                                                                     RequiredField,
                                                                   }) =>
                                                                      FieldName ===
                                                                      "Terms And Conditions" ? null : (
                                                                          <div
                                                                              className="input-6-outer"
                                                                              style={{
                                                                                position: "relative",
                                                                                marginBottom: 10,
                                                                              }}
                                                                              key={key}
                                                                          >
                                                                            {FieldName === "Phone" ? (
                                                                                <div className="input-6">
                                                                                  <div className="phone-input-container">
                                                                                    <PhoneInput
                                                                                        country={
                                                                                          selectedCountry
                                                                                        }
                                                                                        value={
                                                                                          ticketItem.phoneNumber
                                                                                        } // Assuming each ticketType has its own phoneNumber state
                                                                                        onChange={(
                                                                                            value,
                                                                                            country
                                                                                        ) =>
                                                                                            handlePhoneNumberChange(
                                                                                                value,
                                                                                                country,
                                                                                                ticketIndex,
                                                                                                itemIndex,
                                                                                                FormFieldId
                                                                                            )
                                                                                        }
                                                                                        inputProps={{
                                                                                          name: "phone",
                                                                                          required: true,
                                                                                          autocomplete:
                                                                                              "off",
                                                                                          placeholder:
                                                                                          memoizedPlaceholder,
                                                                                        }}
                                                                                        containerStyle={{
                                                                                          borderWidth: 0,
                                                                                        }}
                                                                                        inputStyle={{
                                                                                          border: "none",
                                                                                          marginLeft:
                                                                                              "50px",
                                                                                          width: "80%",
                                                                                        }}
                                                                                        enableSearch={true}
                                                                                        countryCodeEditable={
                                                                                          false
                                                                                        }
                                                                                    />
                                                                                  </div>
                                                                                </div>
                                                                            ) : FieldType ===
                                                                            "Dropdown" ? (
                                                                                <FormGroup>
                                                        <span
                                                            style={{
                                                              fontSize: "16px",
                                                              fontWeight: "550",
                                                            }}
                                                        >
                                                          {FieldName}
                                                          {RequiredField ===
                                                          "True" ? (
                                                              <span
                                                                  style={{
                                                                    color: "red",
                                                                  }}
                                                              >
                                                              {" "}
                                                                *{" "}
                                                            </span>
                                                          ) : null}
                                                        </span>
                                                                                  <FormControl
                                                                                      fullWidth
                                                                                      style={{
                                                                                        height: "50px",
                                                                                      }}
                                                                                  >
                                                                                    <Select
                                                                                        value={
                                                                                          DefaultValue
                                                                                              ? DefaultValue
                                                                                              : "Please Select"
                                                                                        }
                                                                                        name={`${FormFieldId}`}
                                                                                        className="input-6"
                                                                                        style={{
                                                                                          fontSize: "16px",
                                                                                          height: "50px",
                                                                                          paddingLeft: "2%",
                                                                                        }}
                                                                                        onChange={(e) =>
                                                                                            handleChange(
                                                                                                e,
                                                                                                ticketIndex,
                                                                                                itemIndex,
                                                                                                true
                                                                                            )
                                                                                        }
                                                                                        sx={{
                                                                                          fontSize: "16px",
                                                                                          pl: "0px",
                                                                                          opacity: 1,
                                                                                          height: "50px",
                                                                                          "& input": {
                                                                                            opacity: 1,
                                                                                            height: "50px",
                                                                                            padding:
                                                                                                "0px 10px",
                                                                                          },
                                                                                        }}
                                                                                    >
                                                                                      <MenuItem
                                                                                          value="Please Select"
                                                                                          style={{
                                                                                            display: "none",
                                                                                          }}
                                                                                      >
                                                                                        Please Select
                                                                                      </MenuItem>
                                                                                      {(() => {
                                                                                        const foundItem =
                                                                                            Options?.trim()
                                                                                                ?.length > 0
                                                                                                ? JSON.parse(
                                                                                                    Options
                                                                                                )
                                                                                                : [];

                                                                                        if (foundItem) {
                                                                                          return foundItem.map(
                                                                                              (item, i) => (
                                                                                                  <MenuItem
                                                                                                      value={
                                                                                                        item
                                                                                                      }
                                                                                                      key={i}
                                                                                                      style={{
                                                                                                        fontSize:
                                                                                                            "16px",
                                                                                                      }}
                                                                                                  >
                                                                                                    {item}
                                                                                                  </MenuItem>
                                                                                              )
                                                                                          );
                                                                                        }
                                                                                        return null;
                                                                                      })()}
                                                                                    </Select>
                                                                                  </FormControl>
                                                                                </FormGroup>
                                                                            ) : FieldType ===
                                                                            "Radio" ? (
                                                                                <FormGroup>
                                                        <span
                                                            style={{
                                                              fontSize: "16px",
                                                              fontWeight: "550",
                                                            }}
                                                        >
                                                          {FieldName}
                                                          {RequiredField ===
                                                          "True" ? (
                                                              <span
                                                                  style={{
                                                                    color: "red",
                                                                  }}
                                                              >
                                                              {" "}
                                                                *{" "}
                                                            </span>
                                                          ) : null}
                                                        </span>
                                                                                  <RadioGroup
                                                                                      style={{
                                                                                        display: "flex",
                                                                                        flexDirection:
                                                                                            "column",
                                                                                      }}
                                                                                      name={`${FormFieldId}`}
                                                                                      value={DefaultValue}
                                                                                      onChange={(e) =>
                                                                                          handleChange(
                                                                                              e,
                                                                                              ticketIndex,
                                                                                              itemIndex,
                                                                                              true
                                                                                          )
                                                                                      }
                                                                                  >
                                                                                    {(typeof Options ===
                                                                                        "string" &&
                                                                                        Options?.trim()
                                                                                            ?.length > 0
                                                                                            ? JSON.parse(
                                                                                                Options
                                                                                            )
                                                                                            : []
                                                                                    ).map(
                                                                                        (option, index) => (
                                                                                            <FormControlLabel
                                                                                                value={option}
                                                                                                style={{
                                                                                                  lineHeight:
                                                                                                      "0em",
                                                                                                }}
                                                                                                control={
                                                                                                  <Radio
                                                                                                      sx={{
                                                                                                        transform:
                                                                                                            "scale(1.4)",
                                                                                                      }}
                                                                                                      name={`${FormFieldId}`}
                                                                                                  />
                                                                                                }
                                                                                                label={
                                                                                                  <span
                                                                                                      style={{
                                                                                                        fontSize:
                                                                                                            "18px",
                                                                                                      }}
                                                                                                  >
                                                                    {option}
                                                                  </span>
                                                                                                }
                                                                                            />
                                                                                        )
                                                                                    )}
                                                                                  </RadioGroup>
                                                                                </FormGroup>
                                                                            ) : FieldType ===
                                                                            "Multi-Select" ? (
                                                                                <FormGroup
                                                                                    style={{
                                                                                      display: "flex",
                                                                                      flexDirection:
                                                                                          "column",
                                                                                      width: "100%",
                                                                                    }}
                                                                                >
                                                        <span
                                                            style={{
                                                              fontSize: "16px",
                                                              fontWeight: "550",
                                                            }}
                                                        >
                                                          {FieldName}
                                                          {RequiredField ===
                                                          "True" ? (
                                                              <span
                                                                  style={{
                                                                    color: "red",
                                                                  }}
                                                              >
                                                              {" "}
                                                                *{" "}
                                                            </span>
                                                          ) : null}
                                                        </span>
                                                                                  <FormControl>
                                                                                    {(typeof Options ===
                                                                                        "string" &&
                                                                                        Options?.trim()
                                                                                            ?.length > 0
                                                                                            ? JSON.parse(
                                                                                                Options
                                                                                            )
                                                                                            : []
                                                                                    ).map(
                                                                                        (option, index) => (
                                                                                            <FormControlLabel
                                                                                                key={option}
                                                                                                style={{
                                                                                                  marginLeft:
                                                                                                      "0px",
                                                                                                  display:
                                                                                                      "flex",
                                                                                                  gap: "20px",
                                                                                                }}
                                                                                                control={
                                                                                                  <Checkbox
                                                                                                      checked={
                                                                                                        DefaultValue?.length >
                                                                                                        0
                                                                                                            ? DefaultValue?.includes(
                                                                                                                option
                                                                                                            )
                                                                                                            : false
                                                                                                      }
                                                                                                      name={`${FormFieldId}`}
                                                                                                      onChange={(
                                                                                                          e
                                                                                                      ) =>
                                                                                                          handleChange(
                                                                                                              e,
                                                                                                              ticketIndex,
                                                                                                              itemIndex,
                                                                                                              true,
                                                                                                              true
                                                                                                          )
                                                                                                      }
                                                                                                      value={
                                                                                                        option
                                                                                                      }
                                                                                                      style={{
                                                                                                        padding:
                                                                                                            "0px",
                                                                                                      }}
                                                                                                      sx={{
                                                                                                        transform:
                                                                                                            "scale(1.4)",
                                                                                                      }}
                                                                                                  />
                                                                                                }
                                                                                                label={
                                                                                                  <Typography
                                                                                                      style={{
                                                                                                        fontSize:
                                                                                                            "18px",
                                                                                                      }}
                                                                                                  >
                                                                                                    {option}
                                                                                                  </Typography>
                                                                                                }
                                                                                            />
                                                                                        )
                                                                                    )}
                                                                                  </FormControl>
                                                                                </FormGroup>
                                                                            ) : (
                                                                                <div className="input-6">
                                                                                  <div className="div-with-scroll">
                                                                                    <input
                                                                                        className="add_info_input"
                                                                                        id={key} // Use the composite key
                                                                                        name={`${FormFieldId}`}
                                                                                        value={DefaultValue}
                                                                                        type="text"
                                                                                        required
                                                                                        maxLength="260"
                                                                                        onChange={(e) =>
                                                                                            handleChange(
                                                                                                e,
                                                                                                ticketIndex,
                                                                                                itemIndex,
                                                                                                true
                                                                                            )
                                                                                        } // Pass indices
                                                                                    />
                                                                                    {DefaultValue ===
                                                                                        "" && (
                                                                                            <label
                                                                                                htmlFor={key} // Use the composite key
                                                                                                style={{
                                                                                                  position:
                                                                                                      "absolute",
                                                                                                  left: 4,
                                                                                                  fontSize: 15,
                                                                                                  margin: 0,
                                                                                                  fontWeight: 400,
                                                                                                  color:
                                                                                                      "#b1b1b1",
                                                                                                }}
                                                                                            >
                                                                                              {RequiredField ===
                                                                                              "True" ? (
                                                                                                  <span
                                                                                                      style={{
                                                                                                        color:
                                                                                                            "red",
                                                                                                        fontSize:
                                                                                                            "medium",
                                                                                                      }}
                                                                                                  >
                                                                  {" "}
                                                                                                    *{" "}
                                                                </span>
                                                                                              ) : null}
                                                                                              {FieldName}
                                                                                            </label>
                                                                                        )}
                                                                                  </div>
                                                                                </div>
                                                                            )}

                                                                            {FieldName === "Phone" &&
                                                                            phoneError ? (
                                                                                <div
                                                                                    style={{ color: "red" }}
                                                                                >
                                                                                  {phoneError}
                                                                                </div>
                                                                            ) : FieldName ===
                                                                            "Phone" ? (
                                                                                <div>
                                                        <span
                                                            style={{
                                                              color: "red",
                                                            }}
                                                        >
                                                          *{" "}
                                                        </span>
                                                                                  Phone Number
                                                                                </div>
                                                                            ) : null}
                                                                            {(FieldName ===
                                                                                    "Full Name" ||
                                                                                    FieldName === "Email") &&
                                                                                !IsValid && (
                                                                                    <div
                                                                                        style={{
                                                                                          color: "red",
                                                                                        }}
                                                                                    >
                                                                                      {ErrorMessage}
                                                                                    </div>
                                                                                )}
                                                                          </div>
                                                                      )
                                                              )}
                                                        </div>
                                                      </div>
                                                  );
                                                })
                                        );
                                      })()}
                                    </div>
                                ) : (
                                    <div className="input-group">
                                      {additionalInfo
                                          .filter(
                                              (field) =>
                                                  field.FieldName === "Full Name" ||
                                                  field.FieldName === "Email" ||
                                                  field.FieldName === "Phone" ||
                                                  field.IsForAllTickets ||
                                                  field.AssociatedIds.includes(
                                                      newCartItems[0].TicketId
                                                  )
                                          )
                                          .map(
                                              ({
                                                 FieldName,
                                                 FormFieldId,
                                                 DefaultValue,
                                                 IsValid,
                                                 ErrorMessage,
                                                 Options,
                                                 RequiredField,
                                                 FieldType,
                                               }) => {
                                                if (FieldName === "Terms And Conditions")
                                                  return null; // Skip Terms and Conditions field

                                                return (
                                                    <div
                                                        className="input-6-outer"
                                                        style={{
                                                          position: "relative",
                                                          marginBottom: 10,
                                                        }}
                                                        key={FormFieldId}
                                                    >
                                                      {FieldName === "Phone" ? (
                                                          <div className="input-6">
                                                            <div className="phone-input-container">
                                                              <PhoneInput
                                                                  country={selectedCountry}
                                                                  value={phoneNumber}
                                                                  onChange={(value, country) =>
                                                                      handlePhoneNumberChange(
                                                                          value,
                                                                          country,
                                                                          null,
                                                                          null,
                                                                          FormFieldId
                                                                      )
                                                                  }
                                                                  inputProps={{
                                                                    name: "phone",
                                                                    required: true,
                                                                    autocomplete: "off",
                                                                    placeholder:
                                                                    memoizedPlaceholder,
                                                                  }}
                                                                  containerStyle={{
                                                                    borderWidth: 0,
                                                                  }}
                                                                  inputStyle={{
                                                                    border: "none",
                                                                    marginLeft: "50px",
                                                                    width: "80%",
                                                                  }}
                                                                  enableSearch={true}
                                                                  countryCodeEditable={false}
                                                              />
                                                            </div>
                                                          </div>
                                                      ) : FieldType === "Dropdown" ? (
                                                          <FormGroup>
                                          <span
                                              style={{
                                                fontSize: "16px",
                                                fontWeight: "550",
                                              }}
                                          >
                                            {FieldName}
                                            {RequiredField === "True" ? (
                                                <span
                                                    style={{
                                                      color: "red",
                                                    }}
                                                >
                                                {" "}
                                                  *{" "}
                                              </span>
                                            ) : null}
                                          </span>
                                                            <FormControl
                                                                fullWidth
                                                                style={{
                                                                  height: "50px",
                                                                }}
                                                            >
                                                              <Select
                                                                  value={
                                                                    DefaultValue
                                                                        ? DefaultValue
                                                                        : "Please Select"
                                                                  }
                                                                  name={`${FormFieldId}`}
                                                                  className="input-6"
                                                                  style={{
                                                                    fontSize: "16px",
                                                                    height: "50px",
                                                                    paddingLeft: "2%",
                                                                  }}
                                                                  onChange={(e) =>
                                                                      handleChange(
                                                                          e,
                                                                          null,
                                                                          null,
                                                                          false
                                                                      )
                                                                  }
                                                                  sx={{
                                                                    fontSize: "16px",
                                                                    pl: "0px",
                                                                    opacity: 1,
                                                                    height: "50px",
                                                                    "& input": {
                                                                      opacity: 1,
                                                                      height: "50px",
                                                                      padding: "0px 10px",
                                                                    },
                                                                  }}
                                                              >
                                                                <MenuItem
                                                                    value="Please Select"
                                                                    style={{
                                                                      display: "none",
                                                                    }}
                                                                >
                                                                  Please Select
                                                                </MenuItem>
                                                                {(() => {
                                                                  const foundItem =
                                                                      Options?.trim()?.length > 0
                                                                          ? JSON.parse(Options)
                                                                          : [];

                                                                  if (foundItem) {
                                                                    return foundItem.map(
                                                                        (item, i) => (
                                                                            <MenuItem
                                                                                value={item}
                                                                                key={i}
                                                                                style={{
                                                                                  fontSize: "16px",
                                                                                }}
                                                                            >
                                                                              {item}
                                                                            </MenuItem>
                                                                        )
                                                                    );
                                                                  }
                                                                  return null;
                                                                })()}
                                                              </Select>
                                                            </FormControl>
                                                          </FormGroup>
                                                      ) : FieldType === "Radio" ? (
                                                          <FormGroup>
                                          <span
                                              style={{
                                                fontSize: "16px",
                                                fontWeight: "550",
                                              }}
                                          >
                                            {FieldName}
                                            {RequiredField === "True" ? (
                                                <span
                                                    style={{
                                                      color: "red",
                                                    }}
                                                >
                                                {" "}
                                                  *{" "}
                                              </span>
                                            ) : null}
                                          </span>
                                                            <RadioGroup
                                                                style={{
                                                                  display: "flex",
                                                                  flexDirection: "column",
                                                                }}
                                                                name={`${FormFieldId}`}
                                                                value={DefaultValue}
                                                                onChange={(e) =>
                                                                    handleChange(e, null, null, false)
                                                                }
                                                            >
                                                              {(typeof Options === "string" &&
                                                                  Options?.trim()?.length > 0
                                                                      ? JSON.parse(Options)
                                                                      : []
                                                              ).map((option, index) => (
                                                                  <FormControlLabel
                                                                      value={option}
                                                                      style={{ lineHeight: "0em" }}
                                                                      control={
                                                                        <Radio
                                                                            sx={{
                                                                              transform: "scale(1.4)",
                                                                            }}
                                                                            name={`${FormFieldId}`}
                                                                        />
                                                                      }
                                                                      label={
                                                                        <span
                                                                            style={{
                                                                              fontSize: "18px",
                                                                            }}
                                                                        >
                                                    {option}
                                                  </span>
                                                                      }
                                                                  />
                                                              ))}
                                                            </RadioGroup>
                                                          </FormGroup>
                                                      ) : FieldType === "Multi-Select" ? (
                                                          <FormGroup
                                                              style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                width: "100%",
                                                              }}
                                                          >
                                          <span
                                              style={{
                                                fontSize: "16px",
                                                fontWeight: "550",
                                              }}
                                          >
                                            {FieldName}
                                            {RequiredField === "True" ? (
                                                <span
                                                    style={{
                                                      color: "red",
                                                    }}
                                                >
                                                {" "}
                                                  *{" "}
                                              </span>
                                            ) : null}
                                          </span>
                                                            <FormControl>
                                                              {(typeof Options === "string" &&
                                                                  Options?.trim()?.length > 0
                                                                      ? JSON.parse(Options)
                                                                      : []
                                                              ).map((option, index) => (
                                                                  <FormControlLabel
                                                                      key={option}
                                                                      style={{
                                                                        marginLeft: "0px",
                                                                        display: "flex",
                                                                        gap: "20px",
                                                                      }}
                                                                      control={
                                                                        <Checkbox
                                                                            checked={
                                                                              DefaultValue?.length > 0
                                                                                  ? DefaultValue?.includes(
                                                                                      option
                                                                                  )
                                                                                  : false
                                                                            }
                                                                            name={`${FormFieldId}`}
                                                                            onChange={(e) =>
                                                                                handleChange(
                                                                                    e,
                                                                                    null,
                                                                                    null,
                                                                                    false,
                                                                                    true
                                                                                )
                                                                            }
                                                                            value={option}
                                                                            sx={{
                                                                              transform: "scale(1.4)",
                                                                            }}
                                                                        />
                                                                      }
                                                                      label={
                                                                        <Typography
                                                                            style={{
                                                                              fontSize: "18px",
                                                                            }}
                                                                        >
                                                                          {option}
                                                                        </Typography>
                                                                      }
                                                                  />
                                                              ))}
                                                            </FormControl>
                                                          </FormGroup>
                                                      ) : (
                                                          <div className="input-6">
                                                            <div className="div-with-scroll">
                                                              <input
                                                                  className="add_info_input"
                                                                  id={FormFieldId}
                                                                  name={`${FormFieldId}`}
                                                                  value={DefaultValue}
                                                                  type="text"
                                                                  required
                                                                  maxLength="260"
                                                                  onChange={(e) =>
                                                                      handleChange(
                                                                          e,
                                                                          null,
                                                                          null,
                                                                          false
                                                                      )
                                                                  }
                                                              />
                                                              {!DefaultValue && (
                                                                  <label
                                                                      htmlFor={FormFieldId}
                                                                      style={{
                                                                        position: "absolute",
                                                                        left: 4,
                                                                        fontSize: 15,
                                                                        margin: 0,
                                                                        fontWeight: 400,
                                                                        color: "#b1b1b1",
                                                                      }}
                                                                  >
                                                                    {RequiredField === "True" ? (
                                                                        <span
                                                                            style={{
                                                                              color: "red",
                                                                            }}
                                                                        >
                                                    {" "}
                                                                          *{" "}
                                                  </span>
                                                                    ) : null}
                                                                    {FieldName}
                                                                  </label>
                                                              )}
                                                            </div>
                                                          </div>
                                                      )}

                                                      {FieldName === "Phone" && phoneError ? (
                                                          <div style={{ color: "red" }}>
                                                            {phoneError}
                                                          </div>
                                                      ) : FieldName === "Phone" ? (
                                                          <div>
                                          <span
                                              style={{
                                                color: "red",
                                              }}
                                          >
                                            *{" "}
                                          </span>
                                                            Phone Number
                                                          </div>
                                                      ) : null}
                                                      {(FieldName === "Full Name" ||
                                                              FieldName === "Email") &&
                                                          !IsValid && (
                                                              <div style={{ color: "red" }}>
                                                                {ErrorMessage}
                                                              </div>
                                                          )}
                                                    </div>
                                                );
                                              }
                                          )}
                                    </div>
                                )}

                                {additionalInfo.some(
                                        (f) => f.FieldName === "Terms And Conditions")
                                    && checkboxValue && (
                                        <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              marginBottom: 20,
                                              position: "relative",
                                              left: "-10px",
                                              wordBreak: "break-word",
                                            }}
                                        >
                                          <Checkbox
                                              id="topping"
                                              name="topping"
                                              checked={isChecked}
                                              onChange={handleOnChange}
                                              sx={{ color: red[500], padding: "9px" }}
                                              style={{ padding: "9px" }}
                                          />
                                          <div>
                                            <p
                                                style={{
                                                  color: !isChecked && red[500],
                                                  whiteSpace: "pre-line",
                                                }}
                                            >
                                              <Linkify
                                                  componentDecorator={(
                                                      decoratedHref,
                                                      decoratedText,
                                                      key
                                                  ) => (
                                                      <a
                                                          href={decoratedHref}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                          onClick={(e) => {
                                                            e.preventDefault();
                                                            openInNewTab(decoratedHref);
                                                          }}
                                                          key={key}
                                                      >
                                                        {decoratedText}
                                                      </a>
                                                  )}
                                              >
                                                {checkboxValue}
                                              </Linkify>
                                            </p>
                                          </div>
                                        </div>
                                    )}
                              </div>
                          )}

                          {width <= 800 && newCartItems?.length > 0 && (
                              <div class="order-summary-mobile">
                                <h2>{Text.OrderSummary}</h2>
                                <hr style={{ backgroundColor: "black", height: 1 }} />
                                {/* <div class="border-bottom" /> */}

                                {newCartItems?.map((item, idx) => (
                                    <div key={idx}>
                                      <div class="order-description" style={{marginBottom:"10px"}}>
                                        <ul>
                                          <li style={{ fontWeight: 600 }}>
                                            {item.Quantity} x {item.Title}
                                          </li>
                                        </ul>
                                        <ul>
                                          <li>
                                            {
                                              shoppingCartDetails?.CartSession
                                                  ?.CurrencySymbol
                                            }
                                            {(
                                                item?.Quantity * Number(item?.Price)
                                            ).toFixed(2)}
                                          </li>
                                        </ul>
                                      </div>
                                      {item.addon?.map((addon, i) => (
                                          <div
                                              key={i}
                                              className="order-description"
                                              style={{ margin: "0 0 0rem 2.5rem" }}
                                          >
                                            <ul style={{ marginBottom: 0,maxWidth:"250px" }}>
                                              <li>
                                                Add On - {addon.Name} - {item.Title}{" "}
                                                Ticket {addon.person}
                                              </li>
                                            </ul>
                                            <ul style={{ marginBottom: 0 }}>
                                              <li>
                                                {
                                                  shoppingCartDetails?.CartSession
                                                      ?.CurrencySymbol
                                                }
                                                {Intl.NumberFormat("en-US", {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                }).format(addon.Price)}
                                              </li>
                                            </ul>
                                          </div>
                                      ))}
                                      {item?.RecurringTicket === "True" && (
                                          <div className="date-description">
                                            <ul>
                                              <li
                                                  dangerouslySetInnerHTML={{
                                                    __html: eventDateDetails(item).replace(
                                                        /\n/g,
                                                        "<br />"
                                                    ),
                                                  }}
                                              ></li>
                                            </ul>
                                          </div>
                                      )}
                                    </div>
                                ))}

                                <div>
                                  {/* <div class="border-bottom" /> */}
                                  <hr style={{ backgroundColor: "black", height: 1 }} />

                                  <div class="grand-total">
                                    <ul>
                                      <li>{Text.SubTotal}</li>
                                      {discount > 0 ? (
                                          <li style={{ color: "#47c94d" }}>
                                            {titleWithToolTip("Discount", "Discount")}
                                          </li>
                                      ) : null}

                                      <li>
                                        {titleWithToolTip(
                                            "Fee",
                                            "This fee helps operate UBMe and power your next event experience!"
                                        )}
                                      </li>
                                      <li>
                                        {titleWithToolTip(
                                            cartItems[0]?.TaxName !== null
                                                ? cartItems[0]?.TaxName
                                                : "Taxes & Additional Fees",
                                            "Taxes and additional fees are set by the organizer."
                                        )}
                                      </li>
                                    </ul>
                                    <ul style={{ textAlign: "right" }}>
                                      <li>
                                        {
                                          shoppingCartDetails?.CartSession
                                              ?.CurrencySymbol
                                        }
                                        {Intl.NumberFormat("en-US", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }).format(subTotal)}
                                      </li>
                                      {discount > 0 ? (
                                          <li style={{ color: "#47c94d" }}>
                                            {" "}
                                            -{" "}
                                            {
                                              shoppingCartDetails?.CartSession
                                                  ?.CurrencySymbol
                                            }
                                            {Intl.NumberFormat("en-US", {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            }).format(discount)}
                                          </li>
                                      ) : null}
                                      <li>
                                        {
                                          shoppingCartDetails?.CartSession
                                              ?.CurrencySymbol
                                        }
                                        {Intl.NumberFormat("en-US", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }).format(fee + cardProcessingFee)}
                                      </li>
                                      <li>
                                        {
                                          shoppingCartDetails?.CartSession
                                              ?.CurrencySymbol
                                        }
                                        {Intl.NumberFormat("en-US", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }).format(tax)}
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                {newCartItems?.length > 0 ? (
                                    <div>
                                      {" "}
                                      <div class="full-rupees">
                                        <ul>
                                          <li>Total</li>
                                        </ul>
                                        <ul>
                                          <li>
                                            {
                                              shoppingCartDetails?.CartSession
                                                  ?.CurrencySymbol
                                            }
                                            {Intl.NumberFormat("en-US", {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            }).format(totalPriceWithCCFee)}
                                          </li>
                                        </ul>
                                      </div>
                                      {/* <div class="border-bottom" />{" "} */}
                                    </div>
                                ) : null}
                                {isPromo && DiscountCodeExist === "True" ? (
                                    <div>
                                      {(newCartItems && newCartItems?.length > 0) ||
                                      discountData.ResponseCode ? (
                                          <div style={{ position: "relative" }}>
                                            {isPromoCode && (
                                                <>
                                                  {promoCode && (
                                                      <span
                                                          onClick={() => {
                                                            const data = {
                                                              DiscountType: "",
                                                              disCountAmount: 0.0,
                                                              disCountId: "",
                                                              TicketsId: [],
                                                              RemainingUtilization: "",
                                                              ResponseCode: false,
                                                              DiscountCode: "",
                                                            };
                                                            dispatch(GetDiscountData(data));
                                                            setPromoCode("");
                                                            setDiscountError("");
                                                            ApplyPromoCode("");
                                                          }}
                                                          style={{
                                                            position: "absolute",
                                                            top: 18,
                                                            right: 22,
                                                            cursor: "pointer",
                                                          }}
                                                      >
                                        <AiFillCloseCircle size={20} />
                                      </span>
                                                  )}

                                                  <input
                                                      type="text"
                                                      value={promoCode}
                                                      onChange={(e) =>
                                                          setPromoCode(e.target.value)
                                                      }
                                                      className="promo_code_feild"
                                                      placeholder="Promo code"
                                                  />
                                                </>
                                            )}

                                            {discountError !== "" && promoCode !== "" && (
                                                <p
                                                    style={{
                                                      // position: "absolute",
                                                      textAlign: "center",
                                                      fontWeight: 600,
                                                      color: "#f03063",
                                                      bottom: -6,
                                                      left: 36,
                                                      fontSize: 16,
                                                      padding: "10px 0px",
                                                    }}
                                                >
                                                  {discountError}
                                                </p>
                                            )}
                                            {discountError === "" &&
                                                appliedCode !== "" &&
                                                discountData.ResponseCode && (
                                                    <p
                                                        style={{
                                                          // position: "absolute",
                                                          textAlign: "center",
                                                          fontWeight: 600,
                                                          color:
                                                              appliedCode ===
                                                              "Discount is not applicable for this ticket"
                                                                  ? "#f03063"
                                                                  : "#47c94d",
                                                          bottom: -6,
                                                          left: 36,
                                                          fontSize: 16,
                                                          padding: "10px 0px",
                                                        }}
                                                    >
                                                      {/* {discountError} */}
                                                      {`${appliedCode}`}
                                                    </p>
                                                )}
                                            <div className="ticket_add_promo_box">
                                  <span
                                      onClick={() => ApplyPromoCode(promoCode)}
                                      className="ticket_add_promo_btn"
                                  >
                                    {promoCode === ""
                                        ? "Add promo code "
                                        : "Apply promo code"}{" "}
                                    <RiCoupon3Fill style={{ marginLeft: 10 }} />
                                  </span>
                                            </div>
                                          </div>
                                      ) : null}
                                    </div>
                                ) : null}
                              </div>
                          )}

                          {clientSecret && paymentIntent?.PublicKey ? (
                              <React.Fragment>
                                <div class="payment">
                                  <h1>{constants.Text.Payment}</h1>
                                  {/* <input type="text" placeholder="Card number*" /> */}
                                </div>
                                <Elements options={options} stripe={stripePromise}>
                                  <CheckoutForm
                                      ref={checkoutFormRef}
                                      dispatch={dispatch}
                                      isNotFilled={isNotFilled}
                                      createPaymentIntent={createPaymentIntent}
                                      currentEventDetails={currentEventDetails}
                                      returnUrl={returnUrl}
                                      onPaymentMethodChange={setSelectedPaymentMethod}
                                  />
                                </Elements>
                              </React.Fragment>
                          ) : (
                              !isFreeTicket && (
                                  <div
                                      style={{
                                        gap: 10,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: 20,
                                        borderRadius: 15,
                                        backgroundColor: "#e3fff1",
                                      }}
                                  >
                                    <p
                                        style={{
                                          color: "rgb(0, 171, 85)",
                                          textAlign: "center",
                                        }}
                                    >
                                      {constants.Text.StriptAccountPending}{" "}
                                    </p>
                                    <HiOutlineExclamationCircle
                                        color="rgb(0, 171, 85)"
                                        size={20}
                                    />{" "}
                                  </div>
                              )
                          )}
                        </div>
                      </main>

                      {
                          isFreeTicket && (
                              <div className="payment-button-free">
                                <div
                                    class="purchase-button"
                                    style={{ paddingRight: "2.5rem" }}
                                >
                                  {/*{width < 800 && cartItems.length > 0 ? (*/}
                                  {/*    <a*/}
                                  {/*        className="open_summury_btn"*/}
                                  {/*        onClick={() => setShowOrderSummary(!showOrderSummary)}*/}
                                  {/*        href="#"*/}
                                  {/*    >*/}
                                  {/*      {showOrderSummary ? "Hide Summary " : "View Summary"}*/}
                                  {/*    </a>*/}
                                  {/*) : null}*/}
                                  <button
                                      disabled={isNotFilled || freeBtndisabled}
                                      onClick={() => {
                                        setFreeBtndisabled(true);
                                        PersistFreeOrder();
                                      }}
                                      className="purchase-link"
                                      style={{
                                        margin: 0,
                                        backgroundColor:
                                            isNotFilled || freeBtndisabled
                                                ? ((currentEventDetails?.EventColor !== undefined && currentEventDetails.EventColor !== "") ? currentEventDetails.EventColor : "#c31491") + "66"
                                                : ((currentEventDetails?.EventColor !== undefined && currentEventDetails.EventColor !== "") ? currentEventDetails.EventColor : "#c31491"),
                                        width: 160,
                                        padding: "10px 0px",
                                      }}
                                  >
                                    {constants.Text.PlaceOrder}
                                  </button>
                                </div>
                              </div>
                          )
                        // : (
                        // <>
                        //   {width < 800 && cartItems.length > 0 ? (
                        //       <div className="payment-button-paid">
                        //         <a
                        //             className="open_summury_btn"
                        //             onClick={() => setShowOrderSummary(!showOrderSummary)}
                        //             href="#"
                        //         >
                        //           {showOrderSummary ? "Hide Summary " : "View Summary"}
                        //         </a>
                        //       </div>
                        //   ) : null}
                        // </>
                        // )
                      }
                    </div>

                    <OrderSummary
                        {...{ newCartItemsData, setNewCartItemsData, ticketQty }}
                        Token={Token}
                        showOrderSummary={showOrderSummary}
                        setShowOrderSummary={setShowOrderSummary}
                        isPromo={true}
                        DiscountExist={DiscountCodeExist}
                        setOpenCheckOut={setOpenCheckOut}
                        payment_id={paymentIntent?.paymentId}
                        setLeaveCheckOut={setLeaveCheckOut}
                        onPersistCart={handlePersistCart}
                        hasCheckoutQuery={hasCheckoutQuery}
                        selectedPaymentMethod={selectedPaymentMethod}
                    />
                  </div>
              )}
            </React.Fragment>
        )}
      </>
  );
};
const mapStateToProps = (state) => {
  return {
    results: state.loginResponse.results,
    isLoggedIn: state.loginResponse.isLoggedIn,
    currentEventDetails: state.eventReducer.currentEventDetails,
    shoppingCartDetails: state.eventReducer.createshoppingCartDetails,
    cartItems: state.eventReducer.cartData,
    discountData: state.eventReducer.discountData,
    paymentIntent: state.eventReducer.paymentIntent,
  };
};
const matchDispatchToProps = (dispatch) => {
  return {
    ticktesCartItem,
    GetAllOrderFormFieldsByEventId,
    PersistShoppingCartSession,
    GetDiscountData,
    GetDiscountDetails,
    dispatch,
  };
};
export default connect(mapStateToProps, matchDispatchToProps)(Payment);
